import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
// import { uploadImage } from '../../Services/azure-storage-blob';
import Search from '../../../src/assets/images/svg/search.svg';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { uploadImage } from '../../Services/r2-storage-blob.js';
import { _axios } from '../../utils/axios.jsx';


// const parseLRCToJSON = (lrcContent) => {
//     const lines = lrcContent.split('\n');
//     const lyricsLines = [];

//     lines.forEach(line => {
//         const match = line.match(/\[(\d{2}):(\d{2})\.(\d{2})\](.*)/);
//         if (match) {
//             const minutes = parseInt(match[1]);
//             const seconds = parseInt(match[2]);
//             const milliseconds = parseInt(match[3]);
//             const time = minutes * 60 + seconds + milliseconds / 100;
//             const text = match[4].trim();

//             if (text) {
//                 lyricsLines.push({ time, text });
//             }
//         }
//     });

//     return { lines: lyricsLines };
// };

const processHtmlForPreview = (html) => {
    if (!html) return '<p>Your content will appear here...</p>';

    // Create a temporary div to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Style all ol elements
    const olElements = tempDiv.querySelectorAll('ol');
    olElements.forEach(ol => {
        ol.style.paddingLeft = '20px';
        ol.style.margin = '10px 0';
        ol.style.listStyleType = 'decimal';
        ol.style.listStylePosition = 'outside';
        ol.style.display = 'block';
    });

    // Style all ul elements
    const ulElements = tempDiv.querySelectorAll('ul');
    ulElements.forEach(ul => {
        ul.style.paddingLeft = '20px';
        ul.style.margin = '10px 0';
        ul.style.listStyleType = 'disc';
        ul.style.listStylePosition = 'outside';
        ul.style.display = 'block';
    });

    // Style all li elements
    const liElements = tempDiv.querySelectorAll('li');
    liElements.forEach(li => {
        li.style.display = 'list-item';
        li.style.margin = '5px 0';
        li.style.lineHeight = '1.6';
        li.style.listStylePosition = 'outside';
    });

    return tempDiv.innerHTML;
};

const EditLearning = ({ show, onHide, artifactData }) => {
    const videoRef = useRef(null);

    // Add new states for text literature functionality
    const [htmlContent, setHtmlContent] = useState('');
    const [showPreview, setShowPreview] = useState(false);
    const [hasLyrics, setHasLyrics] = useState(false);
    const SUPPORTED_LANGUAGES = [
        { code: 'en', name: 'English', field: 'title', descField: 'short_description' },
        { code: 'hi', name: 'Hindi', field: 'title_hin', descField: 'short_description_hin' },
        { code: 'mr', name: 'Marathi', field: 'title_mar', descField: 'short_description_mar' },
        { code: 'gu', name: 'Gujarati', field: 'title_guj', descField: 'short_description_guj' }
    ];
    const [descriptionByLanguage, setDescriptionByLanguage] = useState({
        en: '',
        hi: '',
        mr: '',
        gu: ''
    });
    const [contentByLanguage, setContentByLanguage] = useState({
        en: '',
        hi: '',
        mr: '',
        gu: ''
    });
    const [activeContentTab, setActiveContentTab] = useState('en');
    const [filesByLanguage, setFilesByLanguage] = useState({
        en: { main: null, thumbnail: null },
        hi: { main: null },
        mr: { main: null },
        gu: { main: null }
    });
    const [currentMediaByLanguage, setCurrentMediaByLanguage] = useState({
        en: { main_url: '' },
        hi: { main_url: '' },
        mr: { main_url: '' },
        gu: { main_url: '' }
    });
    const sunEditorOptions = {
        buttonList: [
            ['undo', 'redo'],
            ['font', 'fontSize', 'formatBlock'],
            ['bold', 'italic', 'underline', 'strike'],
            ['fontColor', 'hiliteColor'],
            ['align', 'list', 'lineHeight'],
            ['outdent', 'indent'],
            ['link'],
            ['fullScreen'],
            // ['preview']
        ],
        height: 200,
        placeholder: 'Enter your literature content here...',
        resizingBar: false,
        showPathLabel: false,
        charCounter: false,
        maxCharCount: null
    };

    // Quill editor configuration
    // const quillModules = {
    //     toolbar: [
    //         [{ 'header': [1, 2, 3, false] }],
    //         ['bold', 'italic', 'underline', 'strike'],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         [{ 'indent': '-1' }, { 'indent': '+1' }],
    //         ['link', 'image'],
    //         [{ 'align': [] }],
    //         [{ 'color': ['#000000'] }], // Only black color
    //         ['clean']
    //     ],
    // };

    // const quillFormats = [
    //     'header', 'bold', 'italic', 'underline', 'strike',
    //     'list', 'bullet', 'indent', 'link', 'image',
    //     'align', 'color', 'background'
    // ];

    const [formData, setFormData] = useState({
        title: '',
        title_hin: '',           // ADD THIS
        title_mar: '',           // ADD THIS
        title_guj: '',
        description: '',
        artifactType: '',
        status: '',
        category: '',
        relatedWaypoint: '',
        selectedWaypoints: [],
        subscriptionType: 'FREE',
        waypoint_id: null,
        promotions: {
            trending: false,
            byGuruji: false
        },
        contentType: {
            course: false,
            explore: false
        },
        author: '',
        languages: '',

    });
    const [waypointResults, setWaypointResults] = useState([]);
    const [waypointName, setWaypointName] = useState('');
    const [isPlaying, setIsPlaying] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [deityResults, setDeityResults] = useState([]);
    const [selectedDeities, setSelectedDeities] = useState([]);
    const [journeyResults, setJourneyResults] = useState([]);
    const [selectedJourneys, setSelectedJourneys] = useState([]);
    const [searchDeity, setSearchDeity] = useState('');
    const [searchJourney, setSearchJourney] = useState('');
    const [saintResults, setSaintResults] = useState([]);
    const [selectedSaints, setSelectedSaints] = useState([]);
    const [searchSaint, setSearchSaint] = useState('');

    const [projectResults, setProjectResults] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [searchProject, setSearchProject] = useState('');
    const [enabledLanguages, setEnabledLanguages] = useState({
        en: false,  // English enabled by default
        hi: false,
        mr: false,
        gu: false
    });
    const [isEditorReady, setIsEditorReady] = useState(false);
    const [hasContainer, setHasContainer] = useState(false);
    const [containerOption, setContainerOption] = useState('EXISTING');
    const [allContainers, setAllContainers] = useState([]);
    // const [selectedContainerId, setSelectedContainerId] = useState('');
    const [selectedContainers, setSelectedContainers] = useState([]);
    const [searchContainer, setSearchContainer] = useState('');
    const [newContainerName, setNewContainerName] = useState('');
    const [newContainerNameHin, setNewContainerNameHin] = useState('');
    const [newContainerNameMar, setNewContainerNameMar] = useState('');
    const [newContainerNameGuj, setNewContainerNameGuj] = useState('');
    const [containerThumbnail, setContainerThumbnail] = useState(null);
    const [containerThumbnailUrl, setContainerThumbnailUrl] = useState('');
    const [existingContainerData, setExistingContainerData] = useState(null);
    const [allListenContainers, setAllListenContainers] = useState([]);
    const [selectedListenContainers, setSelectedListenContainers] = useState([]);
    const [searchListenContainer, setSearchListenContainer] = useState('');
    const [watchFlag, setWatchFlag] = useState(false);
    const [listenFlag, setListenFlag] = useState(false);
    const [readFlag, setReadFlag] = useState(false);

    const [allReadArtifacts, setAllReadArtifacts] = useState([]);
    const [allListenArtifacts, setAllListenArtifacts] = useState([]);
    const [allWatchArtifacts, setAllWatchArtifacts] = useState([]);

    const [selectedReadId, setSelectedReadId] = useState('');
    const [selectedReadArtifact, setSelectedReadArtifact] = useState(null);
const [readSearch, setReadSearch] = useState('');
    const [selectedListenId, setSelectedListenId] = useState('');
    const [selectedWatchId, setSelectedWatchId] = useState('');
    const [selectedListenArtifact, setSelectedListenArtifact] = useState(null);
const [selectedWatchArtifact, setSelectedWatchArtifact] = useState(null);
const [listenSearch, setListenSearch] = useState('');
const [watchSearch, setWatchSearch] = useState('');

    const getDeities = async () => {
        const response = await _axios.get(`${ServerPath}/deity`);
        console.log('Deity result', response);
        const actualData = response?.data.data;
        setDeityResults(actualData);
    }

    const getJourneys = async () => {
        const response = await _axios.get(`${ServerPath}/tripdetails`);
        console.log('Journeys', response);
        const actualData = response?.data.data;
        setJourneyResults(actualData);
    }

    const getContainers = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/artifacts/containers`);
            console.log('Containers:', response);
            if (response?.data?.success) {
                setAllContainers(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching containers:', error);
            toast.error('Failed to load containers');
        }
    };

    useEffect(() => {
        if (
            artifactData?.listen_container_id &&
            (artifactData?.artifactType === 'AUDIO_ORALS') &&
            (artifactData?.category === 21)
        ) {
            getListenContainers();
        }
    }, [artifactData]);

    const getListenContainers = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/artifacts/listen-containers`);
            console.log('Listen Containers:', response);
            if (response?.data?.success) {
                setAllListenContainers(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching listen containers:', error);
            toast.error('Failed to load listen containers');
        }
    };

    const getSaints = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/saints/list/1?limit=1000`);
            console.log('Saints result:', response);
            if (response?.data?.success === 1) {
                setSaintResults(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching saints:', error);
            toast.error('Failed to load saints');
        }
    };

    const getProjects = async () => {
        try {
            const response = await _axios.post(`${ServerPath}/projects`, {
                page: 1,
                limit: 1000,
                searchText: '',
                project_types: [],
                regions: [],
                beneficiaries: []
            });
            console.log('Projects result:', response);
            if (response?.data?.success === 1) {
                setProjectResults(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching projects:', error);
            toast.error('Failed to load projects');
        }
    };
    const getReadArtifacts = async () => {
        try {
            const response = await axios.get(`${ServerPath}/artifacts/dropdown/read`);
            if (response?.data?.success) setAllReadArtifacts(response.data.data);
        } catch (error) {
            console.error('Error fetching read artifacts:', error);
        }
    };

    const getListenArtifacts = async () => {
        try {
            const response = await axios.get(`${ServerPath}/artifacts/dropdown/listen`);
            if (response?.data?.success) setAllListenArtifacts(response.data.data);
        } catch (error) {
            console.error('Error fetching listen artifacts:', error);
        }
    };

    const getWatchArtifacts = async () => {
        try {
            const response = await axios.get(`${ServerPath}/artifacts/dropdown/watch`);
            if (response?.data?.success) setAllWatchArtifacts(response.data.data);
        } catch (error) {
            console.error('Error fetching watch artifacts:', error);
        }
    };

    useEffect(() => {
        getDeities();
        getJourneys();
        getContainers();
        getSaints();
        getProjects();
        getReadArtifacts();
        getListenArtifacts();
        getWatchArtifacts();
    }, []);

    useEffect(() => {
        if (
            (formData.artifactType === 'audio or orals' || formData.artifactType === 'AUDIO_ORALS') &&
            (formData.category === 'MANTRAS_CHANTS' || formData.category === 21)
        ) {
            console.log('Fetching listen containers for AUDIO_ORALS + MANTRAS_CHANTS');
            getListenContainers();
        }
    }, [formData.artifactType, formData.category]);
    useEffect(() => {
        if (
            artifactData?.listen_container_id &&
            artifactData?.artifactType === 'AUDIO_ORALS' &&
            artifactData?.category === 21 &&
            allListenContainers.length > 0
        ) {
            console.log('Loading existing listen container:', artifactData.listen_container_id);

            // Parse comma-separated container IDs
            const listenContainerIds = artifactData.listen_container_id.toString().split(',').map(id => id.trim());

            // Find matching containers from allListenContainers
            const matchedContainers = listenContainerIds
                .map(id => allListenContainers.find(c => c.container_id === id))
                .filter(Boolean);

            console.log('Matched listen containers:', matchedContainers);

            if (matchedContainers.length > 0) {
                setSelectedListenContainers(matchedContainers);
                setHasContainer(true);
                setContainerOption('EXISTING');
            }
        }
    }, [artifactData, allListenContainers]);

    const [files, setFiles] = useState({
        main: null,
        thumbnail: null,
        lyricsData: null
    });

    // const [charCount, setCharCount] = useState(0);
    const [currentMedia, setCurrentMedia] = useState({
        media_url: '',
        thumbnail_url: ''
    });
    const [insights, setInsights] = useState({
        total_views: 0,
        total_clicks: 0,
        avg_duration: 0
    });

    const FILE_VALIDATIONS = {
        TEXT_LITERATURE: {
            allowedTypes: ['application/pdf'],
            maxSize: 3 * 1024 * 1024, // 3MB
            errorMessage: "Please ensure the document is in PDF format. The file size should be less than 1 MB."
        },
        AUDIO_ORALS: {
            allowedTypes: ['audio/mpeg', 'audio/wave', 'audio/wav'],
            maxSize: 10 * 1024 * 1024, // 10MB
            errorMessage: "Please ensure the audio file is in MP3 format. The file size should be less than 5 MB."
        },
        LONG_VIDEOS: {
            allowedTypes: ['video/mp4', 'video/quicktime'],
            maxSize: 20 * 1024 * 1024, // 20MB
            errorMessage: "Please ensure the video file is in MP4/MOV format. The file size should be less than 20 MB, or the video length should not exceed 10 minutes."
        },
        SHORTS_REELS: {
            allowedTypes: ['video/mp4', 'video/quicktime'],
            maxSize: 10 * 1024 * 1024, // 10MB
            errorMessage: "Please ensure the shorts video file is in MP4/MOV format. The file size should be less than 10 MB, or the shorts/reels length should not exceed 60 seconds."
        }
    };

    const [allAuthors, setAllAuthors] = useState([]); // Stores the full fetched list of authors
    const [filteredAuthors, setFilteredAuthors] = useState([]); // Stores authors matching current input
    const [showAuthorSuggestions, setShowAuthorSuggestions] = useState(false); // Controls visibility
    const [authorsError, setAuthorsError] = useState(null);
    const authorInputContainerRef = useRef(null);


    useEffect(() => {
        const fetchAllAuthors = async () => {
            try {
                const url = `${ServerPath}/artifacts/authors/list`; // Your unique authors API endpoint
                const response = await _axios.get(url);

                const fetchedAuthors = response?.data?.data;

                if (response?.data?.success === 1 && Array.isArray(fetchedAuthors)) {
                    setAllAuthors(fetchedAuthors);
                    // Initially, show all authors if the input is empty on focus
                    // or filter if there's already a value
                    setFilteredAuthors(fetchedAuthors.filter(author =>
                        author.toLowerCase().includes(formData.author.toLowerCase())
                    ));
                } else {
                    throw new Error(response?.data?.message || 'Unexpected authors API response format');
                }
            } catch (err) {
                console.error("Error fetching all authors:", err);
                if (axios.isAxiosError(err)) {
                    setAuthorsError(err.response?.data?.message || err.message || "Network or server error fetching authors");
                } else {
                    setAuthorsError(err.message || "An unexpected error occurred while fetching authors");
                }
            }
        };

        fetchAllAuthors();
    }, []);

    const getVideoDuration = (file) => {
        return new Promise((resolve) => {
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                resolve(video.duration);
            };
            video.src = URL.createObjectURL(file);
        });
    };

    const validateFile = (file, artifactType, isThumbmail = false) => {
        if (isThumbmail) {
            const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
            if (!allowedTypes.includes(file.type)) {
                return { isValid: false, message: "Please ensure the thumbnail is in PNG, JPG or WEBPformat." };
            }
            const maxSize = 3 * 1024 * 1024; // 3MB
            if (file.size > maxSize) {
                return { isValid: false, message: "Thumbnail size should be less than 3 MB" };
            }
            return { isValid: true };
        }
        const validation = FILE_VALIDATIONS[artifactType];
        if (!validation) return { isValid: false, message: "Invalid artifact type" };

        if (!validation.allowedTypes.includes(file.type)) {
            return { isValid: false, message: validation.errorMessage };
        }

        if (file.size > validation.maxSize) {
            return { isValid: false, message: validation.errorMessage };
        }

        return { isValid: true };
    };

    const getUploadPath = (file, type, artifactType) => {
        let folder = '';
        switch (artifactType) {
            case 'TEXT_LITERATURE':
                folder = type === 'main' ? 'pdf' : 'pdf/thumbnails';
                break;
            case 'AUDIO_ORALS':
                folder = type === 'main' ? 'audios' : 'audios/thumbnails';
                break;
            case 'LONG_VIDEOS':
                folder = type === 'main' ? 'videos' : 'videos/thumbnails';
                break;
            case 'SHORTS_REELS':
                folder = type === 'main' ? 'shorts' : 'shorts/thumbnails';
                break;
            default:
                folder = 'other';
        }
        return folder;
    };

    const fetchInsights = async (artifactId) => {
        try {
            const response = await _axios.get(`${ServerPath}/artifacts/${artifactId}/insights`);
            if (response.data.success) {
                setInsights(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching insights:', error);
        }
    };

    useEffect(() => {
        if (artifactData?.artifact_id) {
            fetchInsights(artifactData.artifact_id);

            const intervalId = setInterval(() => {
                fetchInsights(artifactData.artifact_id);
            }, 30000);

            return () => clearInterval(intervalId);
        }
    }, [artifactData]);

    useEffect(() => {
        if (artifactData) {
            setIsEditorReady(false); // ✅ ADDED - Hide editor while loading

            let initialWaypoints = [];
            let initialDeities = [];
            let initialJourneys = [];
            console.log("Full artifactData received:", artifactData);
            console.log("Course value:", artifactData.is_a_part_of_course,
                "Type:", typeof artifactData.is_a_part_of_course);
            console.log("Explore value:", artifactData.is_a_part_of_explore,
                "Type:", typeof artifactData.is_a_part_of_explore);

            // Initialize HTML content for text literature
            if (artifactData.artifactType === 'TEXT_LITERATURE' && artifactData.media_url) {
                // If media_url contains HTML content, set it
                if (typeof artifactData.media_url === 'string' && artifactData.media_url.includes('<')) {
                    setHtmlContent(artifactData.media_url);
                }
            }
            if (artifactData.artifactType === 'TEXT_LITERATURE') {
                setContentByLanguage({
                    en: artifactData.media_url || '',
                    hi: artifactData.media_url_hin || '',
                    mr: artifactData.media_url_mar || '',
                    gu: artifactData.media_url_guj || ''
                });
                setHtmlContent(artifactData.media_url || ''); // Keep for backward compatibility
                setCurrentMediaByLanguage({
                    en: { main_url: '' },
                    hi: { main_url: '' },
                    mr: { main_url: '' },
                    gu: { main_url: '' }
                });
            } else {
                // For non-text artifacts, initialize currentMediaByLanguage with existing URLs
                setCurrentMediaByLanguage({
                    en: { main_url: artifactData.media_url || '' },
                    hi: { main_url: artifactData.media_url_hin || '' },
                    mr: { main_url: artifactData.media_url_mar || '' },
                    gu: { main_url: artifactData.media_url_guj || '' }
                });
            }
            setCurrentMedia({
                media_url: artifactData.media_url || '',
                thumbnail_url: artifactData.thumbnail_url || ''
            });
            if (artifactData.lyrics_data) {
                setFiles(prev => ({
                    ...prev,
                    lyricsData: artifactData.lyrics_data
                }));
            }
            setHasLyrics(Boolean(artifactData.lyrics_data && artifactData.lyrics_data.lines && artifactData.lyrics_data.lines.length > 0));

            if (artifactData.waypoint_name && (!artifactData.waypoint_id || artifactData.waypoint_id === "")) {
                // For case when we only have waypoint names but no IDs
                const parseWaypointNames = (str) => {
                    const result = [];
                    let inQuotes = false;
                    let currentName = '';

                    for (let i = 0; i < str.length; i++) {
                        const char = str[i];

                        if (char === '"') {
                            inQuotes = !inQuotes;
                            continue;
                        }

                        if (char === ',' && !inQuotes) {
                            result.push(currentName.trim());
                            currentName = '';
                            continue;
                        }

                        currentName += char;
                    }

                    if (currentName.trim()) {
                        result.push(currentName.trim());
                    }

                    return result;
                };

                const names = parseWaypointNames(artifactData.waypoint_name);
                console.log("Parsed waypoint names (no IDs):", names);

                // First set empty waypoints so UI shows something is loading
                initialWaypoints = [];

                // Modified approach to handle waypoints with commas
                Promise.all(names.map(name => {
                    // Use only the first part of the name before any comma for searching
                    const searchTerm = name.split(',')[0].trim();
                    console.log(`Searching for waypoint with term: ${searchTerm} (from full name: ${name})`);
                    return _axios.get(`${ServerPath}/artifacts/search-waypoints?term=${encodeURIComponent(searchTerm)}`);
                })).then(responses => {
                    const validWaypoints = [];

                    responses.forEach((response, index) => {
                        const fullName = names[index];

                        if (response.data.success && response.data.data.length > 0) {
                            // For names with commas, we're less strict with matching
                            if (fullName.includes(',')) {
                                console.log(`Adding waypoint with comma: ${fullName}`);
                                // Just use the first result and preserve our full name
                                validWaypoints.push({
                                    wpt_id: response.data.data[0].wpt_id,
                                    wpt_name: fullName
                                });
                            } else {
                                // For names without commas, try exact match
                                const matchedWaypoint = response.data.data.find(w =>
                                    w.wpt_name.trim().toLowerCase() === fullName.trim().toLowerCase()
                                );

                                if (matchedWaypoint) {
                                    validWaypoints.push({
                                        wpt_id: matchedWaypoint.wpt_id,
                                        wpt_name: matchedWaypoint.wpt_name
                                    });
                                } else {
                                    // If no exact match, use the first result
                                    validWaypoints.push({
                                        wpt_id: response.data.data[0].wpt_id,
                                        wpt_name: fullName
                                    });
                                }
                            }
                        } else {
                            // If no results at all, create a temporary ID to preserve the waypoint
                            console.log(`No results for waypoint: ${fullName}, creating temporary entry`);
                            validWaypoints.push({
                                wpt_id: `temp_${Date.now()}_${index}`,
                                wpt_name: fullName
                            });
                        }
                    });

                    console.log("Valid waypoints after modified API calls:", validWaypoints);

                    // Update form data with all waypoints
                    setFormData(prev => ({
                        ...prev,
                        selectedWaypoints: validWaypoints,
                        waypoint_id: validWaypoints.filter(w => !String(w.wpt_id).startsWith('temp_')).map(w => w.wpt_id).join(',')
                    }));
                }).catch(error => {
                    console.error('Error fetching waypoints:', error);
                });
            } else if (artifactData.waypoint_name && artifactData.waypoint_id) {
                // For case when we have both IDs and names
                const ids = artifactData.waypoint_id.toString().split(',').map(id => id.trim());
                console.log("Waypoint IDs:", ids);

                // Better waypoint name parsing
                const parseWaypointNames = (str) => {
                    const result = [];
                    let inQuotes = false;
                    let currentName = '';

                    for (let i = 0; i < str.length; i++) {
                        const char = str[i];

                        if (char === '"') {
                            inQuotes = !inQuotes;
                            continue;
                        }

                        if (char === ',' && !inQuotes) {
                            result.push(currentName.trim());
                            currentName = '';
                            continue;
                        }

                        currentName += char;
                    }

                    if (currentName.trim()) {
                        result.push(currentName.trim());
                    }

                    return result;
                };

                const names = parseWaypointNames(artifactData.waypoint_name);
                console.log("Parsed waypoint names:", names);

                // Map IDs to names, ensuring all waypoints are preserved
                initialWaypoints = [];

                // Make sure we include all waypoints, even if names and IDs don't match up perfectly
                const maxLength = Math.max(ids.length, names.length);
                for (let i = 0; i < maxLength; i++) {
                    initialWaypoints.push({
                        wpt_id: i < ids.length ? ids[i] : `temp_${Date.now()}_${i}`,
                        wpt_name: i < names.length ? names[i] : `Waypoint ${i + 1}`
                    });
                }

                console.log("Final mapped waypoints:", initialWaypoints);
            }
            if (artifactData.deity_id && deityResults.length > 0) {
                const deityIds = artifactData.deity_id.toString().split(',').map(id => id.trim());
                initialDeities = deityIds.map(deityId => {
                    const matchedDeity = deityResults.find(deity => deity.deity_id.toString() === deityId);
                    return matchedDeity || { deity_id: deityId, deity_name: `Deity ${deityId}` };
                }).filter(Boolean);
            }

            // Handle journeys initialization  
            if (artifactData.journey_id && journeyResults.length > 0) {
                const journeyIds = artifactData.journey_id.toString().split(',').map(id => id.trim());
                initialJourneys = journeyIds.map(journeyId => {
                    const matchedJourney = journeyResults.find(journey => journey.journey_id.toString() === journeyId);
                    return matchedJourney || { journey_id: journeyId, trip_name: `Journey ${journeyId}` };
                }).filter(Boolean);
            }

            // Handle saints initialization
            let initialSaints = [];
            if (artifactData.saint_id && saintResults.length > 0) {
                const saintIds = artifactData.saint_id.toString().split(',').map(id => id.trim());
                initialSaints = saintIds.map(saintId => {
                    const matchedSaint = saintResults.find(saint => saint.id.toString() === saintId);
                    return matchedSaint || { id: saintId, name: `Saint ${saintId}` };
                }).filter(Boolean);
            }

            // Handle projects initialization
            let initialProjects = [];
            if (artifactData.project_id && projectResults.length > 0) {
                const projectIds = artifactData.project_id.toString().split(',').map(id => id.trim());
                initialProjects = projectIds.map(projectId => {
                    const matchedProject = projectResults.find(project => project.project_id.toString() === projectId);
                    return matchedProject || { project_id: projectId, project_title: `Project ${projectId}` };
                }).filter(Boolean);
            }

            // Set the selected arrays


            setFormData({
                title: artifactData.title || '',
                title_hin: artifactData.title_hin || '',        // ADD THIS
                title_mar: artifactData.title_mar || '',        // ADD THIS  
                title_guj: artifactData.title_guj || '',
                description: artifactData.description || '',
                artifactType: artifactData.artifactType || '',
                status: artifactData.status || '',
                category: artifactData.category || '',
                subscriptionType: 'FREE',
                promotions: {
                    trending: artifactData.promotions?.trending || false,
                    byGuruji: artifactData.promotions?.byGuruji || false
                },
                contentType: {
                    course: Boolean(Number(artifactData.is_a_part_of_course)),
                    explore: Boolean(Number(artifactData.is_a_part_of_explore))
                },
                selectedWaypoints: initialWaypoints,
                waypoint_id: initialWaypoints.filter(w => !String(w.wpt_id).startsWith('temp_')).map(w => w.wpt_id).join(','),
                relatedWaypoint: '',
                author: artifactData.author || '',
                languages: artifactData.languages || ''
            });
            setDescriptionByLanguage({
                en: artifactData.description || '',        // ← Changed from short_description
                hi: artifactData.description_hin || '',    // ← Changed from short_description_hin  
                mr: artifactData.description_mar || '',    // ← Changed from short_description_mar
                gu: artifactData.description_guj || ''     // ← Changed from short_description_guj
            });

            // setEnabledLanguages({
            //     en: true, // English always enabled
            //     hi: Boolean(artifactData.title_hin),
            //     mr: Boolean(artifactData.title_mar),
            //     gu: Boolean(artifactData.title_guj)
            // });
            const langFlags = artifactData.lang_flag ? artifactData.lang_flag.split(',') : ['en'];
            setEnabledLanguages({
                en: langFlags.includes('en'),
                hi: langFlags.includes('hi'),
                mr: langFlags.includes('mr'),
                gu: langFlags.includes('gu')
            });

            setCurrentMediaByLanguage({
                en: { main_url: artifactData.media_url || '' },
                hi: { main_url: artifactData.media_url_hin || '' },
                mr: { main_url: artifactData.media_url_mar || '' },
                gu: { main_url: artifactData.media_url_guj || '' }
            });

            // setCharCount(artifactData.description?.length || 0);
            setCurrentMedia({
                media_url: artifactData.media_url || '',
                thumbnail_url: artifactData.thumbnail_url || ''
            });

            setWaypointName('');
            setSelectedDeities(initialDeities);
            setSelectedJourneys(initialJourneys);
            setSelectedSaints(initialSaints);
            setSelectedProjects(initialProjects);

            // Debug log to confirm what's being set
            console.log("Form data waypoints set to:", initialWaypoints);

            // Load existing container data if present
            if (artifactData.container_id && allContainers.length > 0) {
                setHasContainer(true);
                setContainerOption('EXISTING');

                // Parse comma-separated container IDs
                const containerIds = artifactData.container_id.toString().split(',').map(id => id.trim());
                const matchedContainers = containerIds
                    .map(id => allContainers.find(c => c.container_id === id))
                    .filter(Boolean);

                setSelectedContainers(matchedContainers);

                // Set first container as existingContainerData for backward compatibility
                if (matchedContainers.length > 0) {
                    setExistingContainerData(matchedContainers[0]);
                }
            } else {
                setHasContainer(false);
                setSelectedContainers([]);
                setExistingContainerData(null);
            }
            if (artifactData.listen_container_id && allListenContainers.length > 0) {
                const listenContainerIds = artifactData.listen_container_id.toString().split(',').map(id => id.trim());
                const matchedListenContainers = listenContainerIds
                    .map(id => allListenContainers.find(c => c.container_id === id))
                    .filter(Boolean);
                setSelectedListenContainers(matchedListenContainers);
            }

            setWatchFlag(artifactData.watch_flag == 1);
            setListenFlag(artifactData.listen_flag == 1);
            setReadFlag(artifactData.read_flag == 1);

            if (artifactData.listen_id) {
    const match = allListenArtifacts.find(a => a.artifact_id == artifactData.listen_id);
    if (match) setSelectedListenArtifact(match);
}
if (artifactData.watch_id) {
    const match = allWatchArtifacts.find(a => a.artifact_id == artifactData.watch_id);
    if (match) setSelectedWatchArtifact(match);
}
            setSelectedReadId(artifactData.read_id || '');


            // ✅ ADDED - Use setTimeout to ensure all state updates complete first
            setTimeout(() => {
                setIsEditorReady(true);
            }, 100);
        }
    }, [artifactData, deityResults, journeyResults, saintResults, projectResults]);

    const handleContentTypeChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            contentType: {
                ...prev.contentType,
                [name]: checked
            }
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'title') {
            if (value.length > 45) {
                toast.error('Title cannot exceed 45 characters');
                return;
            }
        }



        // if (name === 'description') {
        //     // Description validation
        //     if (value.length > 300) {
        //         toast.error('Description cannot exceed 300 characters');
        //         return;
        //     }
        //     setCharCount(value.length);
        // }

        // if (name === 'artifactType') {
        //     // Show warning toast first
        //     if (currentMedia.media_url || currentMedia.thumbnail_url) {
        //         toast.warning('Please upload new files according to the selected artifact type');
        //     }

        //     // Set validation flag
        //     setFormData(prev => ({
        //         ...prev,
        //         [name]: value,
        //         requireNewFiles: true // Add this flag
        //     }));

        //     // Reset files and media URLs
        //     setFiles({
        //         main: null,
        //         thumbnail: null
        //     });
        //     setCurrentMedia({
        //         media_url: '',
        //         thumbnail_url: ''
        //     });

        //     // Reset HTML content when artifact type changes
        //     setHtmlContent('');
        //     return; // Add return to prevent the default setFormData below
        // }
        if (name === 'artifactType') {
            // Show warning toast first
            if (currentMedia.media_url || currentMedia.thumbnail_url ||
                Object.values(currentMediaByLanguage).some(lang => lang.main_url) ||
                Object.values(filesByLanguage).some(lang => lang.main)) {
                toast.warning('Changing artifact type will clear all uploaded content. Please upload new files according to the selected type.');
            }

            setReadFlag(false);
            setListenFlag(false);
            setWatchFlag(false);
            setSelectedListenId('');
            setSelectedReadId('');
            setSelectedReadArtifact(null);
setReadSearch('');
            setSelectedWatchId('');
            setSelectedListenArtifact(null);
setSelectedWatchArtifact(null);
setListenSearch('');
setWatchSearch('');

            // Clear ALL existing content and files
            setFormData(prev => ({
                ...prev,
                [name]: value,
                requireNewFiles: true
            }));

            // Reset all file states
            setFiles({
                main: null,
                thumbnail: null,
                lyricsData: null
            });

            // Reset all media URLs
            setCurrentMedia({
                media_url: '',
                thumbnail_url: ''
            });

            // Reset multilingual content
            setContentByLanguage({
                en: '',
                hi: '',
                mr: '',
                gu: ''
            });
            setDescriptionByLanguage({
                en: '',
                hi: '',
                mr: '',
                gu: ''
            });

            // Reset multilingual file states
            setFilesByLanguage({
                en: { main: null, thumbnail: null },
                hi: { main: null },
                mr: { main: null },
                gu: { main: null }
            });

            // Reset multilingual media URLs
            setCurrentMediaByLanguage({
                en: { main_url: '' },
                hi: { main_url: '' },
                mr: { main_url: '' },
                gu: { main_url: '' }
            });

            // Reset HTML content
            setHtmlContent('');

            return; // Prevent the default setFormData below
        }

        if (name === 'relatedWaypoint') {
            setWaypointName(value);

            if (value.length > 2) {
                const timeoutId = setTimeout(() => {
                    _axios.get(`${ServerPath}/artifacts/search-waypoints?term=${value}`)
                        .then(response => {
                            if (response.data.success) {
                                setWaypointResults(response.data.data);
                            }
                        })
                        .catch(error => console.error('Error searching waypoints:', error));
                }, 300);
                return () => clearTimeout(timeoutId);
            } else {
                setWaypointResults([]);
            }
        }

        // if (name === 'author') {
        //     if (value.length > 30) {
        //         toast.error('Author/Speaker name cannot exceed 30 characters');
        //         return;
        //     }
        // }
        if (name === 'author') {
            if (value.length > 30) {
                toast.error('Author/Speaker name cannot exceed 30 characters');
                return;
            }
            // Filter authors as the user types
            const currentFilter = value.toLowerCase();
            const newFilteredAuthors = allAuthors.filter(author =>
                author.toLowerCase().includes(currentFilter)
            );
            setFilteredAuthors(newFilteredAuthors);
            // Ensure suggestions are shown if input has value or is focused
            setShowAuthorSuggestions(true);
        }

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));

        // if (name === 'description') {
        //     setCharCount(value.length);
        // }
    };

    const handleAuthorInputFocus = () => {
        setShowAuthorSuggestions(true);
        // On focus, filter based on current input, or show all if input is empty
        const currentFilter = formData.author.toLowerCase();
        setFilteredAuthors(allAuthors.filter(author =>
            author.toLowerCase().includes(currentFilter)
        ));
    };
    const handleAuthorInputBlur = () => {
        // Use a timeout to allow click events on suggestions to register
        setTimeout(() => {
            setShowAuthorSuggestions(false);
        }, 300);
    };

    const handleAuthorSelect = (selectedAuthor) => {
        console.log("Author selected:", selectedAuthor);
        setFormData(prev => ({
            ...prev,
            author: selectedAuthor
        }));
        setShowAuthorSuggestions(false); // Hide suggestions immediately after selection
        console.log("New formData.author after selection:", selectedAuthor);
    };

    const handleWaypointSelect = (waypoint) => {
        setFormData(prev => {
            // Check if waypoint is already selected by comparing IDs as strings
            if (prev.selectedWaypoints.some(w => String(w.wpt_id) === String(waypoint.wpt_id))) {
                return prev;
            }

            // Add the waypoint with proper ID
            const updatedWaypoints = [...prev.selectedWaypoints, {
                wpt_id: waypoint.wpt_id,
                wpt_name: waypoint.wpt_name
            }];

            return {
                ...prev,
                selectedWaypoints: updatedWaypoints,
                waypoint_id: updatedWaypoints.map(w => w.wpt_id).join(',')
            };
        });

        setWaypointName('');
        setWaypointResults([]);
    };

    const handleWaypointRemove = (waypointId) => {
        setFormData(prev => {
            // Convert both IDs to strings for comparison
            const updatedWaypoints = prev.selectedWaypoints.filter(w =>
                String(w.wpt_id) !== String(waypointId)
            );

            return {
                ...prev,
                selectedWaypoints: updatedWaypoints,
                waypoint_id: updatedWaypoints.map(w => w.wpt_id).join(',')
            };
        });
    };

    const handleJourneySelect = (journey) => {
        const isAlreadySelected = selectedJourneys.some(j => j.journey_id === journey.journey_id);
        if (isAlreadySelected) {
            return
        } else {
            const updatedJourneys = [...selectedJourneys, journey];
            setSelectedJourneys(updatedJourneys)
            setSearchJourney('');
        }
    };

    const handleDeitySelect = (deity) => {
        const isAlreadySelected = selectedDeities.some(d => d.deity_id === deity.deity_id);
        if (isAlreadySelected) {
            return
        } else {
            const updatedDeity = [...selectedDeities, deity];
            setSelectedDeities(updatedDeity)
            setSearchDeity('');
        }
    };

    const handleJourneyRemove = (journeyId) => {
        const updatedJourneys = selectedJourneys.filter(j => j.journey_id !== journeyId);
        setSelectedJourneys(updatedJourneys);
    };

    const handleDeityRemove = (deityId) => {
        const updatedDeities = selectedDeities.filter(d => d.deity_id !== deityId);
        setSelectedDeities(updatedDeities);
    };

    const handleSaintSelect = (saint) => {
        const isAlreadySelected = selectedSaints.some(s => s.id === saint.id);
        if (isAlreadySelected) {
            return;
        } else {
            const updatedSaints = [...selectedSaints, saint];
            setSelectedSaints(updatedSaints);
            setSearchSaint('');
        }
    };

    const handleSaintRemove = (saintId) => {
        const updatedSaints = selectedSaints.filter(s => s.id !== saintId);
        setSelectedSaints(updatedSaints);
    };

    const handleProjectSelect = (project) => {
        const isAlreadySelected = selectedProjects.some(p => p.project_id === project.project_id);
        if (isAlreadySelected) {
            return;
        } else {
            const updatedProjects = [...selectedProjects, project];
            setSelectedProjects(updatedProjects);
            setSearchProject('');
        }
    };

    const handleProjectRemove = (projectId) => {
        const updatedProjects = selectedProjects.filter(p => p.project_id !== projectId);
        setSelectedProjects(updatedProjects);
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            promotions: {
                ...prev.promotions,
                [name]: checked
            }
        }));
    };

    const handleFileChange = async (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        console.log('File Change Started:', {
            type,
            newFile: file,
            currentFiles: files,
            currentMedia: currentMedia,
            fileType: file.type,
            artifactType: formData.artifactType
        });

        // Reset video state when new file is selected
        setIsPlaying(false);

        try {
            if (type === 'main') {
                const validation = validateFile(file, formData.artifactType);
                if (!validation.isValid) {
                    toast.error(validation.message);
                    return;
                }

                console.log('Before clearing media URL:', currentMedia);

                if (formData.artifactType === 'SHORTS_REELS' && file.type.startsWith('video/')) {
                    const duration = await getVideoDuration(file);
                    if (duration > 60) {
                        toast.error('Short video duration should not exceed 60 seconds');
                        return;
                    }
                }
                // Clear previous media URL immediately
                await setCurrentMedia(prev => {
                    console.log('Clearing media URL, prev state:', prev);
                    const newState = {
                        ...prev,
                        media_url: '',
                        thumbnail_url: '' // Also clear thumbnail when new main file is uploaded
                    };
                    console.log('New media state after clearing:', newState);
                    return newState;
                });

                // Clear previous files
                await setFiles(prev => {
                    console.log('Clearing files, prev state:', prev);
                    const newState = {
                        ...prev,
                        main: null,
                        thumbnail: null
                    };
                    console.log('New files state after clearing:', newState);
                    return newState;
                });

                console.log('Before setting new file:', files);

                // Set the new file
                await setFiles(prev => {
                    console.log('Setting new file, prev state:', prev);
                    const newState = {
                        ...prev,
                        [type]: file
                    };
                    console.log('New files state after setting main file:', newState);
                    return newState;
                });

                // Handle video files
                if (file.type.startsWith('video/')) {
                    console.log('Processing video file for thumbnail generation');
                    try {
                        const thumbnailFile = await generateThumbnail(file);
                        console.log('Generated thumbnail:', thumbnailFile);

                        await setFiles(prev => {
                            console.log('Setting thumbnail file, prev state:', prev);
                            const newState = {
                                ...prev,
                                thumbnail: thumbnailFile
                            };
                            console.log('New files state after setting thumbnail:', newState);
                            return newState;
                        });

                        // Upload thumbnail first
                        const thumbnailFileName = `thumbnail_${Date.now()}`;
                        const thumbnailUploadFolder = getUploadPath(thumbnailFile, 'thumbnail', formData.artifactType);

                        console.log('Uploading thumbnail:', { thumbnailFileName, thumbnailUploadFolder });
                        const thumbnailUrl = await uploadImage(
                            thumbnailFile,
                            thumbnailFileName,
                            thumbnailUploadFolder,
                            thumbnailUploadFolder.split('/')[0]
                        );
                        console.log('Thumbnail uploaded, URL:', thumbnailUrl);

                        await setCurrentMedia(prev => {
                            const newState = {
                                ...prev,
                                thumbnail_url: thumbnailUrl
                            };
                            console.log('New media state after thumbnail upload:', newState);
                            return newState;
                        });

                        toast.success('Thumbnail generated from video');
                    } catch (error) {
                        console.error('Error in thumbnail generation/upload:', error);
                        toast.error('Failed to generate thumbnail from video');
                    }
                }

                // Upload the main file
                const mainFileName = `${type}_${Date.now()}`;
                const mainUploadFolder = getUploadPath(file, type, formData.artifactType);

                console.log('Uploading main file:', { mainFileName, mainUploadFolder });
                const fileUrl = await uploadImage(
                    file,
                    mainFileName,
                    mainUploadFolder,
                    mainUploadFolder.split('/')[0]
                );
                console.log('Main file uploaded, URL:', fileUrl);

                // Update media state with new URL
                await setCurrentMedia(prev => {
                    console.log('Setting new media URL, prev state:', prev);
                    const newState = {
                        ...prev,
                        media_url: fileUrl
                    };
                    console.log('Final media state after main file upload:', newState);
                    return newState;
                });

                toast.success('Main file uploaded successfully');

            } else if (type === 'thumbnail') {
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
                if (!allowedTypes.includes(file.type)) {
                    toast.error("Thumbnail must be in JPG, PNG or WEBP format");
                    return;
                }
                const validation = validateFile(file, formData.artifactType, true);
                if (!validation.isValid) {
                    toast.error(validation.message);
                    return;
                }
                console.log('Processing manual thumbnail upload');
                if (!file.type.startsWith('image/')) {
                    toast.error("Thumbnail must be an image file");
                    return;
                }

                // Clear previous thumbnail
                await setFiles(prev => ({
                    ...prev,
                    thumbnail: null
                }));

                // Set new thumbnail file
                await setFiles(prev => ({
                    ...prev,
                    thumbnail: file
                }));

                // Upload new thumbnail
                const thumbnailFileName = `thumbnail_${Date.now()}`;
                const thumbnailUploadFolder = getUploadPath(file, type, formData.artifactType);

                console.log('Uploading manual thumbnail:', { thumbnailFileName, thumbnailUploadFolder });
                const thumbnailUrl = await uploadImage(
                    file,
                    thumbnailFileName,
                    thumbnailUploadFolder,
                    thumbnailUploadFolder.split('/')[0]
                );
                console.log('Manual thumbnail uploaded, URL:', thumbnailUrl);

                await setCurrentMedia(prev => ({
                    ...prev,
                    thumbnail_url: thumbnailUrl
                }));

                toast.success('Thumbnail uploaded successfully');
            }
            // else if (type === 'lyrics') {
            //     const allowedTypes = ['application/json', 'text/plain'];
            //     if (!allowedTypes.some(t => file.type.includes(t)) && !file.name.match(/\.(json|lrc)$/i)) {
            //         toast.error("Lyrics must be in JSON or LRC format");
            //         return;
            //     }

            //     const reader = new FileReader();
            //     reader.onload = async (e) => {
            //         try {
            //             const content = e.target.result;
            //             let lyricsData;

            //             if (file.name.endsWith('.json')) {
            //                 lyricsData = JSON.parse(content);
            //                 if (!lyricsData.lines || !Array.isArray(lyricsData.lines)) {
            //                     toast.error("Invalid lyrics format. Expected {lines: [{time: number, text: string}]}");
            //                     return;
            //                 }
            //             } else if (file.name.endsWith('.lrc')) {
            //                 lyricsData = parseLRCToJSON(content);
            //             }

            //             setFiles(prev => ({
            //                 ...prev,
            //                 lyrics: file,
            //                 lyricsData: lyricsData
            //             }));

            //             toast.success('Lyrics uploaded successfully');
            //         } catch (error) {
            //             console.error('Error parsing lyrics:', error);
            //             toast.error("Invalid lyrics file format");
            //         }
            //     };
            //     reader.readAsText(file);
            // }
        } catch (error) {
            console.error('Error in handleFileChange:', error);
            toast.error(`Failed to upload ${type === 'main' ? 'main file' : 'thumbnail'}`);

            // Reset states on error
            console.log('Resetting states due to error');
            if (type === 'main') {
                await setFiles(prev => ({
                    ...prev,
                    main: null,
                    thumbnail: null
                }));
                await setCurrentMedia(prev => ({
                    ...prev,
                    media_url: '',
                    thumbnail_url: ''
                }));
            } else {
                await setFiles(prev => ({
                    ...prev,
                    thumbnail: null
                }));
                await setCurrentMedia(prev => ({
                    ...prev,
                    thumbnail_url: ''
                }));
            }
        }

        // Log final states
        console.log('Final states after all operations:', {
            files,
            currentMedia,
            isPlaying
        });
    };

    const handleMultilingualFileChange = async (e, type, languageCode) => {
        const file = e.target.files[0];
        if (!file) return;

        console.log('Multilingual File Change Started:', {
            type,
            languageCode,
            file: file.name,
            fileType: file.type
        });

        // Reset video state
        setIsPlaying(false);

        try {
            // Validation
            const validation = validateFile(file, formData.artifactType);
            if (!validation.isValid) {
                toast.error(validation.message);
                return;
            }

            // Check video duration for shorts
            if (formData.artifactType === 'SHORTS_REELS' && file.type.startsWith('video/')) {
                const duration = await getVideoDuration(file);
                if (duration > 60) {
                    toast.error('Short video duration should not exceed 60 seconds');
                    return;
                }
            }

            // Update state immediately
            setFilesByLanguage(prev => ({
                ...prev,
                [languageCode]: {
                    ...prev[languageCode],
                    [type]: file
                }
            }));

            // Upload to Azure with language suffix
            const fileName = `${type}_${languageCode}_${Date.now()}`;
            const uploadFolder = getUploadPath(file, type, formData.artifactType);
            const fileUrl = await uploadImage(file, fileName, uploadFolder, uploadFolder.split('/')[0]);

            console.log('File uploaded successfully:', fileUrl);

            // Store URL for submission
            setCurrentMediaByLanguage(prev => ({
                ...prev,
                [languageCode]: {
                    ...prev[languageCode],
                    [`${type}_url`]: fileUrl
                }
            }));

            // CRITICAL: Generate thumbnail for video files (only for English to avoid duplicates)
            if (file.type.startsWith('video/') && languageCode === 'en') {
                console.log('Generating thumbnail for English video...');
                try {
                    const thumbnailFile = await generateThumbnail(file);
                    console.log('Thumbnail generated:', thumbnailFile);

                    // Set thumbnail file for main thumbnail display
                    setFiles(prev => ({
                        ...prev,
                        thumbnail: thumbnailFile
                    }));

                    // Upload thumbnail
                    const thumbnailFileName = `thumbnail_${Date.now()}`;
                    const thumbnailUploadFolder = getUploadPath(thumbnailFile, 'thumbnail', formData.artifactType);

                    const thumbnailUrl = await uploadImage(
                        thumbnailFile,
                        thumbnailFileName,
                        thumbnailUploadFolder,
                        thumbnailUploadFolder.split('/')[0]
                    );

                    // Update current media with new thumbnail URL
                    setCurrentMedia(prev => ({
                        ...prev,
                        thumbnail_url: thumbnailUrl
                    }));

                    console.log('Thumbnail uploaded:', thumbnailUrl);
                    toast.success('Thumbnail generated from video');
                } catch (error) {
                    console.error('Error generating thumbnail:', error);
                    toast.error('Failed to generate thumbnail from video');
                }
            }

            const langName = SUPPORTED_LANGUAGES.find(l => l.code === languageCode)?.name;
            toast.success(`${langName} file uploaded successfully`);

        } catch (error) {
            console.error('Error in handleMultilingualFileChange:', error);
            toast.error(`Failed to upload ${languageCode} file`);

            // Reset states on error
            setFilesByLanguage(prev => ({
                ...prev,
                [languageCode]: {
                    ...prev[languageCode],
                    [type]: null
                }
            }));
        }
    };

    // Add multilingual file preview function
    const renderMultilingualFilePreview = (file, type, languageCode) => {
        const existingUrl = currentMediaByLanguage[languageCode]?.main_url;

        // Safety check for filesByLanguage structure
        if (!filesByLanguage[languageCode]) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
                    <span style={{ fontSize: '32px', color: '#A0AEC0' }}>+</span>
                    <p style={{
                        fontSize: '10px',
                        color: '#718096',
                        margin: '0',
                        whiteSpace: 'pre-line',
                        maxWidth: '200px'
                    }}>
                        {getUploadMessage(type, formData.artifactType)}
                    </p>
                </div>
            );
        }

        // Handle new uploaded video files with FULL CONTROLS like original
        if (file && file.type && file.type.startsWith('video/')) {
            return (
                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                    <video
                        key={`${languageCode}-${file.name}`}
                        controls={isPlaying}
                        muted={!isPlaying}
                        playsInline
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsPlaying(!isPlaying);
                            const video = e.target;
                            if (!isPlaying) {
                                video.muted = false;
                                video.play();
                            } else {
                                video.pause();
                                video.currentTime = 0;
                                video.muted = true;
                            }
                        }}
                    >
                        <source src={URL.createObjectURL(file)} type={file.type} />
                    </video>

                    {!isPlaying && (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsPlaying(true);
                                const video = e.target.parentElement.querySelector('video');
                                if (video) {
                                    video.muted = false;
                                    video.play();
                                }
                            }}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '40px',
                                height: '40px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            <div style={{
                                width: '0',
                                height: '0',
                                borderTop: '8px solid transparent',
                                borderBottom: '8px solid transparent',
                                borderLeft: '12px solid white',
                                marginLeft: '3px'
                            }} />
                        </div>
                    )}

                    <div style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        padding: '8px',
                        background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
                        color: 'white',
                        fontSize: '12px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        zIndex: 1
                    }}>
                        {file.name}
                    </div>

                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput(`mainFile_${languageCode}`);
                        }}
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            zIndex: 3
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Handle existing uploaded video files with full controls
        if (!file && existingUrl && (formData.artifactType === 'LONG_VIDEOS' || formData.artifactType === 'SHORTS_REELS')) {
            return (
                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                    <video
                        controls={isPlaying}
                        muted={!isPlaying}
                        playsInline
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsPlaying(!isPlaying);
                            const video = e.target;
                            if (!isPlaying) {
                                video.muted = false;
                                video.play();
                            } else {
                                video.pause();
                                video.currentTime = 0;
                                video.muted = true;
                            }
                        }}
                    >
                        <source src={existingUrl} type="video/mp4" />
                    </video>

                    {!isPlaying && (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsPlaying(true);
                                const video = e.target.parentElement.querySelector('video');
                                if (video) {
                                    video.muted = false;
                                    video.play();
                                }
                            }}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '40px',
                                height: '40px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            <div style={{
                                width: '0',
                                height: '0',
                                borderTop: '8px solid transparent',
                                borderBottom: '8px solid transparent',
                                borderLeft: '12px solid white',
                                marginLeft: '3px'
                            }} />
                        </div>
                    )}

                    <div style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        padding: '8px',
                        background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
                        color: 'white',
                        fontSize: '12px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                    }}>
                        Existing {SUPPORTED_LANGUAGES.find(l => l.code === languageCode)?.name} Video
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(0, 128, 0, 0.8)',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '10px'
                        }}
                    >
                        ✓ Uploaded
                    </div>

                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput(`mainFile_${languageCode}`);
                        }}
                        style={{
                            position: 'absolute',
                            top: '8px',
                            left: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            zIndex: 3
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Handle existing uploaded audio files
        if (!file && existingUrl && formData.artifactType === 'AUDIO_ORALS') {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%', padding: '10px' }}>
                    <div className="mb-2">
                        <i className="bi bi-music-note" style={{ fontSize: '24px', color: '#4A5568' }}></i>
                    </div>
                    <span style={{
                        fontSize: '12px',
                        color: '#4A5568',
                        wordBreak: 'break-word'
                    }}>
                        Existing {SUPPORTED_LANGUAGES.find(l => l.code === languageCode)?.name} Audio
                    </span>
                    <div
                        style={{
                            backgroundColor: 'rgba(0, 128, 0, 0.8)',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '10px',
                            marginTop: '4px'
                        }}
                    >
                        ✓ Uploaded
                    </div>
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput(`mainFile_${languageCode}`);
                        }}
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '10px',
                            marginTop: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Handle new uploaded audio files
        if (file && file.type && file.type.startsWith('audio/')) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%', padding: '10px' }}>
                    <div className="mb-2">
                        <i className="bi bi-music-note" style={{ fontSize: '24px', color: '#4A5568' }}></i>
                    </div>
                    <span style={{
                        fontSize: '12px',
                        color: '#4A5568',
                        wordBreak: 'break-word'
                    }}>
                        {file.name}
                    </span>
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput(`mainFile_${languageCode}`);
                        }}
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '10px',
                            marginTop: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Default empty state
        if (!file) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
                    <span style={{ fontSize: '32px', color: '#A0AEC0' }}>+</span>
                    <p style={{
                        fontSize: '10px',
                        color: '#718096',
                        margin: '0',
                        whiteSpace: 'pre-line',
                        maxWidth: '200px'
                    }}>
                        {getUploadMessage(type, formData.artifactType)}
                    </p>
                </div>
            );
        }

        // Handle other file types
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%', padding: '10px' }}>
                <div className="mb-2">
                    <i className="bi bi-file-earmark" style={{ fontSize: '24px', color: '#4A5568' }}></i>
                </div>
                <span style={{
                    fontSize: '12px',
                    color: '#4A5568',
                    wordBreak: 'break-word'
                }}>
                    {file.name}
                </span>
            </div>
        );
    };
    // Add validation function for content
    // Add validation function for content
    const validateContent = () => {
        // At least ONE enabled language must have content
        const enabledLangCodes = Object.keys(enabledLanguages).filter(code => enabledLanguages[code]);

        if (formData.artifactType === 'TEXT_LITERATURE' && Number(formData.category) === 13) {
            // Ebooks: check R2 links in currentMediaByLanguage
            const hasAnyUrl = enabledLangCodes.some(langCode => currentMediaByLanguage[langCode]?.main_url?.trim());
            if (!hasAnyUrl) {
                toast.error('Please enter at least one PDF link for Ebooks');
                return false;
            }
        } else if (formData.artifactType === 'TEXT_LITERATURE') {
            // ✅ FIX: Check text editor content for TEXT_LITERATURE
            const hasAnyContent = enabledLangCodes.some(langCode => {
                const content = contentByLanguage[langCode];
                return content?.trim() &&
                    content.trim() !== '<p><br></p>' &&
                    content.trim() !== '<p></p>' &&
                    content.trim() !== '';
            });

            if (!hasAnyContent) {
                const enabledLangNames = enabledLangCodes
                    .map(code => SUPPORTED_LANGUAGES.find(l => l.code === code)?.name)
                    .join(', ');
                toast.error(`At least one language content is required from: ${enabledLangNames}`);
                return false;
            }
        } else {
            // ✅ FIX: Check file uploads for other artifact types
            const hasAnyFile = enabledLangCodes.some(langCode => {
                const hasNewFile = filesByLanguage[langCode]?.main;
                const hasExistingUrl = currentMediaByLanguage[langCode]?.main_url;
                return hasNewFile || hasExistingUrl;
            });

            if (!hasAnyFile) {
                const enabledLangNames = enabledLangCodes
                    .map(code => SUPPORTED_LANGUAGES.find(l => l.code === code)?.name)
                    .join(', ');
                toast.error(`At least one language file is required from: ${enabledLangNames}`);
                return false;
            }
        }

        return true;
    };

    const triggerFileInput = (inputId) => {
        document.getElementById(inputId).click();
    };

    const validateContentTypeMatch = () => {
        const { artifactType } = formData;

        if (artifactType === 'TEXT_LITERATURE') {
            // Check if we have HTML content in contentByLanguage
            // const hasTextContent = contentByLanguage.en?.trim() &&
            //     contentByLanguage.en.trim() !== '<p><br></p>' &&
            //     contentByLanguage.en.trim() !== '<p></p>';
            const enabledLangCodes = Object.keys(enabledLanguages).filter(code => enabledLanguages[code]);
            const hasTextContent = enabledLangCodes.some(langCode => {
                const content = contentByLanguage[langCode];
                return content?.trim() &&
                    content.trim() !== '<p><br></p>' &&
                    content.trim() !== '<p></p>';
            });

            // Only check for actual NEW uploaded files, not existing content
            const hasNewUploadedFiles = Object.values(filesByLanguage).some(lang => lang.main !== null && lang.main !== undefined);

            // Also check currentMediaByLanguage for non-empty URLs (but exclude HTML content)
            const hasFileUrls = Object.values(currentMediaByLanguage).some(lang => {
                const url = lang.main_url;
                // Only consider it a "file URL" if it's not empty and doesn't look like HTML content
                return url && url.trim() && !url.includes('<') && !url.includes('html');
            });

            if (!hasTextContent) {
                toast.error('Text Literature requires written content, not file uploads');
                return false;
            }

            if (hasNewUploadedFiles || hasFileUrls) {
                toast.error('Text Literature should contain written content, not uploaded files. Please remove uploaded files or change artifact type.');
                return false;
            }
        }
        else if (artifactType === 'AUDIO_ORALS') {
            // Should have audio files only
            // const hasEnglishContent = filesByLanguage.en?.main || currentMediaByLanguage.en?.main_url;

            // if (!hasEnglishContent) {
            //     toast.error('Audio content requires audio file uploads');
            //     return false;
            // }
            const enabledLangCodes = Object.keys(enabledLanguages).filter(code => enabledLanguages[code]);
            const hasAudioContent = enabledLangCodes.some(langCode => {
                const hasNewFile = filesByLanguage[langCode]?.main;
                const hasExistingUrl = currentMediaByLanguage[langCode]?.main_url?.trim();
                return hasNewFile || hasExistingUrl;
            });

            if (!hasAudioContent) {
                toast.error('Audio content requires audio file uploads');
                return false;
            }

            // Check if uploaded files are actually audio
            const englishFile = filesByLanguage.en?.main;
            if (englishFile && !englishFile.type.startsWith('audio/')) {
                toast.error('Audio artifact type requires audio files (.mp3, .wav), not ' + englishFile.type);
                return false;
            }

            // Check other language files are audio too
            for (const [langCode, langFiles] of Object.entries(filesByLanguage)) {
                if (langCode !== 'en' && langFiles.main && !langFiles.main.type.startsWith('audio/')) {
                    const langName = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.name;
                    toast.error(`${langName} file must be audio format for Audio artifact type`);
                    return false;
                }
            }
        }
        else if (artifactType === 'LONG_VIDEOS' || artifactType === 'SHORTS_REELS') {
            // Should have video files only
            // const hasEnglishContent = filesByLanguage.en?.main || currentMediaByLanguage.en?.main_url;

            // if (!hasEnglishContent) {
            //     toast.error('Video content requires video file uploads');
            //     return false;
            // }
            const enabledLangCodes = Object.keys(enabledLanguages).filter(code => enabledLanguages[code]);
            const hasVideoContent = enabledLangCodes.some(langCode => {
                const hasNewFile = filesByLanguage[langCode]?.main;
                const hasExistingUrl = currentMediaByLanguage[langCode]?.main_url?.trim();
                return hasNewFile || hasExistingUrl;
            });

            if (!hasVideoContent) {
                toast.error('Video content requires video file uploads');
                return false;
            }

            // Check if uploaded files are actually video
            const englishFile = filesByLanguage.en?.main;
            if (englishFile && !englishFile.type.startsWith('video/')) {
                toast.error('Video artifact type requires video files (.mp4, .mov), not ' + englishFile.type);
                return false;
            }

            // Check other language files are video too
            for (const [langCode, langFiles] of Object.entries(filesByLanguage)) {
                if (langCode !== 'en' && langFiles.main && !langFiles.main.type.startsWith('video/')) {
                    const langName = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.name;
                    toast.error(`${langName} file must be video format for Video artifact type`);
                    return false;
                }
            }
        }

        return true;
    };

    const handleContainerCheckboxChange = (e) => {
        const checked = e.target.checked;
        setHasContainer(checked);
        if (!checked) {
            setContainerOption('EXISTING');
            setSelectedContainers([]);
            setSearchContainer('');
            setNewContainerName('');
            setNewContainerNameHin('');
            setNewContainerNameMar('');
            setNewContainerNameGuj('');
            setContainerThumbnail(null);
            setContainerThumbnailUrl('');
            setExistingContainerData(null);
        } else {
            // If checking and there's existing container data, restore it
            if (artifactData?.container_id && allContainers.length > 0) {
                setContainerOption('EXISTING');
                // Parse comma-separated container IDs and find matching containers
                const containerIds = artifactData.container_id.toString().split(',').map(id => id.trim());
                const matchedContainers = containerIds
                    .map(id => allContainers.find(c => c.container_id === id))
                    .filter(Boolean);
                setSelectedContainers(matchedContainers);
            }
        }
    };

    const handleContainerOptionChange = (e) => {
        const value = e.target.value;
        setContainerOption(value);
        if (value === 'EXISTING') {
            setNewContainerName('');
            setNewContainerNameHin('');
            setNewContainerNameMar('');
            setNewContainerNameGuj('');
            setContainerThumbnail(null);
            setContainerThumbnailUrl('');
        } else {
            setSelectedContainers([]);
            setSearchContainer('');
            setExistingContainerData(null);
        }
    };

    const handleContainerThumbnailChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate thumbnail
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
        if (!allowedTypes.includes(file.type)) {
            toast.error("Container thumbnail must be in JPG, PNG or WEBP format");
            return;
        }

        const maxSize = 3 * 1024 * 1024; // 3MB
        if (file.size > maxSize) {
            toast.error('Container thumbnail size should be less than 3 MB');
            return;
        }

        setContainerThumbnail(file);

        // Upload to Azure
        try {
            const fileName = `container_thumbnail_${Date.now()}`;
            const uploadFolder = 'containers';
            const thumbnailUrl = await uploadImage(file, fileName, uploadFolder, 'containers');
            setContainerThumbnailUrl(thumbnailUrl);
            toast.success('Container thumbnail uploaded successfully');
        } catch (error) {
            console.error('Error uploading container thumbnail:', error);
            toast.error('Failed to upload container thumbnail');
        }
    };

    const handleContainerSelect = (container) => {
        const isAlreadySelected = selectedContainers.some(c => c.container_id === container.container_id);
        if (isAlreadySelected) {
            return;
        }
        setSelectedContainers(prev => [...prev, container]);
        setSearchContainer('');
    };

    const handleContainerRemove = (containerId) => {
        setSelectedContainers(prev => prev.filter(c => c.container_id !== containerId));
    };

    const handleListenContainerSelect = (container) => {
        const isAlreadySelected = selectedListenContainers.some(c => c.container_id === container.container_id);
        if (isAlreadySelected) {
            return;
        }
        setSelectedListenContainers(prev => [...prev, container]);
        setSearchListenContainer('');
    };

    const handleListenContainerRemove = (containerId) => {
        setSelectedListenContainers(prev => prev.filter(c => c.container_id !== containerId));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting || isSubmitted) return;
        try {
            setIsSubmitting(true);

            // Validate all 4 titles (now required)
            if (!validateTitles()) {
                setIsSubmitting(false);
                return;
            }
            if (!validateDescriptions()) {
                setIsSubmitting(false);
                return;
            }
            if (!validateContentTypeMatch()) {
                setIsSubmitting(false);
                return;
            }

            // Validate content based on artifact type
            if (!validateContent()) {
                setIsSubmitting(false);
                return;
            }

            // if (!formData.author) {
            //     toast.error('Please select Author/Speaker');
            //     setIsSubmitting(false);
            //     return;
            // }

            // if (!formData.languages) {
            //     toast.error('Please select Language');
            //     setIsSubmitting(false);
            //     return;
            // }

            // if (!formData.description.trim()) {
            //     toast.error('Please enter a valid description');
            //     setIsSubmitting(false);
            //     return;
            // }

            if (!formData.artifactType || !formData.status || !formData.category) {
                toast.error('Please fill in all required fields');
                setIsSubmitting(false);
                return;
            }

            // Prepare multilingual content data
            let mediaUrls = {
                media_url: '', // English
                media_url_hin: '',
                media_url_mar: '',
                media_url_guj: ''
            };

            let thumbnailUrl = currentMedia.thumbnail_url;

            if (formData.artifactType === 'TEXT_LITERATURE' && Number(formData.category) === 13) {
                // Ebooks: use R2 links from currentMediaByLanguage
                mediaUrls.media_url = enabledLanguages.en ? (currentMediaByLanguage.en?.main_url || null) : null;
                mediaUrls.media_url_hin = enabledLanguages.hi ? (currentMediaByLanguage.hi?.main_url || null) : null;
                mediaUrls.media_url_mar = enabledLanguages.mr ? (currentMediaByLanguage.mr?.main_url || null) : null;
                mediaUrls.media_url_guj = enabledLanguages.gu ? (currentMediaByLanguage.gu?.main_url || null) : null;
            } else if (formData.artifactType === 'TEXT_LITERATURE') {
                // Store HTML content for ENABLED languages only, NULL for disabled
                mediaUrls.media_url = enabledLanguages.en ? (contentByLanguage.en || currentMediaByLanguage.en?.main_url || currentMedia.media_url) : null;
                mediaUrls.media_url_hin = enabledLanguages.hi ? (contentByLanguage.hi || currentMediaByLanguage.hi?.main_url || null) : null;
                mediaUrls.media_url_mar = enabledLanguages.mr ? (contentByLanguage.mr || currentMediaByLanguage.mr?.main_url || null) : null;
                mediaUrls.media_url_guj = enabledLanguages.gu ? (contentByLanguage.gu || currentMediaByLanguage.gu?.main_url || null) : null;
            } else {
                // ✅ FIX: Prioritize newly uploaded files over existing URLs
                // For ENABLED languages: New upload → Existing URL → null
                // For DISABLED languages: Always null
                mediaUrls.media_url = enabledLanguages.en ?
                    (currentMediaByLanguage.en?.main_url || currentMedia.media_url || null) : null;
                mediaUrls.media_url_hin = enabledLanguages.hi ?
                    (currentMediaByLanguage.hi?.main_url || null) : null;
                mediaUrls.media_url_mar = enabledLanguages.mr ?
                    (currentMediaByLanguage.mr?.main_url || null) : null;
                mediaUrls.media_url_guj = enabledLanguages.gu ?
                    (currentMediaByLanguage.gu?.main_url || null) : null;
            }

            // Upload new thumbnail if selected
            if (files.thumbnail) {
                const thumbnailFileName = `thumbnail_${Date.now()}`;
                thumbnailUrl = await uploadImage(
                    files.thumbnail,
                    thumbnailFileName,
                    'thumbnails',
                    'images'
                );
            }

            const deities = selectedDeities?.map((deity) => deity?.deity_id);
            const journeys = selectedJourneys.map((journey) => journey?.journey_id);
            const saints = selectedSaints.map((saint) => saint?.id);
            const projects = selectedProjects.map((project) => project?.project_id);

            let containerIdToUse = null;
            if (hasContainer && formData.artifactType === 'TEXT_LITERATURE' && formData.category === 19) {
                if (containerOption === 'NEW') {
                    // Validate new container fields
                    if (!newContainerName.trim()) {
                        toast.error('Container name is required');
                        setIsSubmitting(false);
                        return;
                    }
                    if (!containerThumbnailUrl) {
                        toast.error('Container thumbnail is required');
                        setIsSubmitting(false);
                        return;
                    }
                    // Create new container
                    try {
                        const containerData = {
                            container_name: newContainerName.trim(),
                            container_name_hin: newContainerNameHin.trim() || null,
                            container_name_mar: newContainerNameMar.trim() || null,
                            container_name_guj: newContainerNameGuj.trim() || null,
                            container_thumbnail_url: containerThumbnailUrl,
                            created_by: artifactData?.created_by
                        };
                        const containerResponse = await _axios.post(`${ServerPath}/artifacts/containers`, containerData);
                        if (containerResponse.data.success) {
                            containerIdToUse = containerResponse.data.data.container_id;
                            toast.success('Container created successfully');
                        }
                    } catch (error) {
                        console.error('Error creating container:', error);
                        toast.error(error.response?.data?.message || 'Failed to create container');
                        setIsSubmitting(false);
                        return;
                    }
                } else {
                    // Use existing containers (multi-select)
                    if (selectedContainers.length === 0) {
                        toast.error('Please select at least one container');
                        setIsSubmitting(false);
                        return;
                    }
                    containerIdToUse = selectedContainers.map(c => c.container_id).join(',');
                }
            } else if (!hasContainer) {
                containerIdToUse = null;
            }

            // ADD THIS BLOCK AFTER containerIdToUse LOGIC:
            let listenContainerIdToUse = null;
            if (
                hasContainer &&
                (formData.artifactType === 'audio or orals' || formData.artifactType === 'AUDIO_ORALS') &&
                (formData.category === 'MANTRAS_CHANTS' || formData.category === 21 || Number(formData.category) === 21)
            ) {
                if (containerOption === 'NEW') {
                    if (!newContainerName.trim()) {
                        toast.error('Container name is required');
                        setIsSubmitting(false);
                        return;
                    }
                    if (!containerThumbnailUrl) {
                        toast.error('Container thumbnail is required');
                        setIsSubmitting(false);
                        return;
                    }
                    try {
                        const containerData = {
                            container_name: newContainerName.trim(),
                            container_name_hin: newContainerNameHin.trim() || null,
                            container_name_mar: newContainerNameMar.trim() || null,
                            container_name_guj: newContainerNameGuj.trim() || null,
                            container_thumbnail_url: containerThumbnailUrl,
                            created_by: artifactData?.created_by
                        };
                        const res = await _axios.post(
                            `${ServerPath}/artifacts/listen-containers`,  // ✅ CORRECT ENDPOINT
                            containerData
                        );
                        if (res.data.success) {
                            listenContainerIdToUse = res.data.data.container_id;
                        }
                    } catch (err) {
                        toast.error(err.response?.data?.message || 'Failed to create listen container');
                        setIsSubmitting(false);
                        return;
                    }
                } else {
                    if (selectedListenContainers.length === 0) {
                        toast.error('Please select at least one listen container');
                        setIsSubmitting(false);
                        return;
                    }
                    listenContainerIdToUse = selectedListenContainers.map(c => c.container_id).join(',');
                }
            }

            if (readFlag && selectedReadId.length === 0) {
                toast.error('Please Select Read ID');
                setIsSubmitting(false);
                return;
            }

            if (listenFlag && selectedListenId.length === 0) {
                toast.error('Please Select Listen ID');
                setIsSubmitting(false);
                return;
            }

            if (watchFlag && selectedWatchId.length === 0) {
                toast.error('Please Select Watch ID');
                setIsSubmitting(false);
                return;
            }


            const dataToUpdate = {
                title: formData.title,
                title_hin: formData.title_hin || null,
                title_mar: formData.title_mar || null,
                title_guj: formData.title_guj || null,
                lang_flag: Object.keys(enabledLanguages)      // ← ADD THIS LINE
                    .filter(code => enabledLanguages[code])   // ← ADD THIS LINE
                    .join(','),
                // short_description: enabledLanguages.en ? (descriptionByLanguage.en || null) : null,
                // short_description_hin: enabledLanguages.hi ? (descriptionByLanguage.hi || null) : null,
                // short_description_mar: enabledLanguages.mr ? (descriptionByLanguage.mr || null) : null,
                // short_description_guj: enabledLanguages.gu ? (descriptionByLanguage.gu || null) : null,
                short_description: descriptionByLanguage.en || null,
                short_description_hin: descriptionByLanguage.hi || null,
                short_description_mar: descriptionByLanguage.mr || null,
                short_description_guj: descriptionByLanguage.gu || null,
                artifact_type: formData.artifactType,
                status: formData.status,
                category_id: formData.category,
                subscription_type: formData.subscriptionType,
                is_trending: formData.promotions.trending,
                is_by_guruji: formData.promotions.byGuruji,
                is_a_part_of_course: formData.contentType.course,
                is_a_part_of_explore: formData.contentType.explore,
                ...mediaUrls, // Spread all media URLs
                thumbnail_url: thumbnailUrl,
                waypoint_id: formData.selectedWaypoints
                    .filter(w => w.wpt_id && !String(w.wpt_id).startsWith('temp_'))
                    .map(w => w.wpt_id)
                    .join(','),
                waypoint_name: formData.selectedWaypoints.map(w => w.wpt_name).join(','),
                html_content: formData.artifactType === 'TEXT_LITERATURE' ? contentByLanguage.en : null,
                lyrics_data: files.lyricsData || null,
                // author: formData.author || null,
                // languages: formData.languages || null,
                deity_id: deities.join(','),
                journey_id: journeys.join(','),
                saint_id: saints.join(','),
                project_id: projects.join(','),
                container_id: containerIdToUse,
                listen_container_id: listenContainerIdToUse,
                listen_flag: listenFlag ? 1 : 0,
                read_flag: readFlag ? 1 : 0,
                watch_flag: watchFlag ? 1 : 0,
                listen_id: selectedListenId,
                read_id: selectedReadId,
                watch_id: selectedWatchId,
            };

            const response = await _axios.put(
                `${ServerPath}/artifacts/${artifactData.artifact_id}`,
                dataToUpdate
            );

            if (response.data.success) {
                setIsSubmitted(true);
                onHide(true);
                toast.success('Your record has been successfully saved.');
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        } catch (error) {
            if (!isSubmitted) {
                console.error('Error updating artifact:', error);
                toast.error(error.response?.data?.message || 'Failed to update artifact');
            }
        }
        finally {
            setIsSubmitting(false);
        }
    };

    const getUploadMessage = (type, artifactType) => {
        if (!artifactType) return '';

        if (type === 'thumbnail') {
            return 'Please ensure the document is in JPG, PNG format.';
        }

        const validation = FILE_VALIDATIONS[artifactType];
        if (!validation) return '';

        // Special case for audio
        if (artifactType === 'AUDIO_ORALS') {
            return `Please ensure the audio file is in MP3 format. The file size should be less than 10 MB`;
        }

        const allowedTypes = validation.allowedTypes.map(type => {
            switch (type) {
                case 'application/pdf': return 'PDF';
                case 'audio/mpeg':
                case 'audio/wave':
                case 'audio/wav': return 'MP3';
                case 'video/mp4': return 'MP4';
                case 'video/quicktime': return 'MOV';
                case 'image/gif': return 'GIF';
                default: return type;
            }
        }).join(', ');

        const sizeInMB = validation.maxSize / (1024 * 1024);
        return `Please ensure the document is in ${allowedTypes} format.\nThe file size should be less than ${sizeInMB} MB`;
    };

    const generateThumbnail = (videoFile) => {
        return new Promise((resolve) => {
            const video = document.createElement('video');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            video.autoplay = false;
            video.muted = true;
            video.src = URL.createObjectURL(videoFile);

            video.onloadeddata = () => {
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                video.currentTime = Math.min(1, video.duration);
            };

            video.onseeked = () => {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                canvas.toBlob((blob) => {
                    const thumbnailFile = new File([blob], 'auto-thumbnail.png', { type: 'image/png' });
                    thumbnailFile.preview = URL.createObjectURL(blob);
                    resolve(thumbnailFile);
                    URL.revokeObjectURL(video.src);
                }, 'image/png', 0.8);
            };
        });
    };

    // Modify the renderFilePreview function
    const renderFilePreview = (file, type) => {
        // For video files (either new or existing)
        if ((file && file.type.startsWith('video/')) ||
            (currentMedia.media_url && (formData.artifactType === 'LONG_VIDEOS' || formData.artifactType === 'SHORTS_REELS'))) {
            const videoUrl = file ? URL.createObjectURL(file) : currentMedia.media_url;

            return (
                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                    <video
                        ref={videoRef}
                        controls={isPlaying}
                        muted={!isPlaying}
                        playsInline
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (videoRef.current) {
                                if (!isPlaying) {
                                    videoRef.current.muted = false;
                                    videoRef.current.play().then(() => {
                                        setIsPlaying(true);
                                    });
                                } else {
                                    videoRef.current.pause();
                                    videoRef.current.currentTime = 0;
                                    videoRef.current.muted = true;
                                    setIsPlaying(false);
                                }
                            }
                        }}
                    >
                        <source src={videoUrl} type="video/mp4" />
                    </video>

                    {!isPlaying && (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                if (videoRef.current) {
                                    videoRef.current.muted = false;
                                    videoRef.current.play().then(() => {
                                        setIsPlaying(true);
                                    });
                                }
                            }}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '40px',
                                height: '40px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            <div style={{
                                width: '0',
                                height: '0',
                                borderTop: '8px solid transparent',
                                borderBottom: '8px solid transparent',
                                borderLeft: '12px solid white',
                                marginLeft: '3px'
                            }} />
                        </div>
                    )}

                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput('mainFile');
                        }}
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            zIndex: 3
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Rest of your existing renderFilePreview code...
        if (!file && !currentMedia[type === 'main' ? 'media_url' : 'thumbnail_url']) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
                    <span style={{ fontSize: '32px', color: '#A0AEC0' }}>+</span>
                    <p style={{
                        fontSize: '10px',
                        color: '#718096',
                        margin: '0',
                        whiteSpace: 'pre-line',
                        maxWidth: '200px'
                    }}>
                        {getUploadMessage(type, formData.artifactType)}
                    </p>
                </div>
            );
        }
        // if (type === 'lyrics') {
        //     // Check for existing lyrics data
        //     if (!file && !files.lyricsData) {
        //         return (
        //             <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
        //                 <span style={{ fontSize: '32px', color: '#A0AEC0' }}>♪</span>
        //                 <p style={{
        //                     fontSize: '10px',
        //                     color: '#718096',
        //                     margin: '0',
        //                     whiteSpace: 'pre-line',
        //                     maxWidth: '200px'
        //                 }}>
        //                     Upload lyrics in JSON or LRC format
        //                 </p>
        //             </div>
        //         );
        //     }

        //     if (files.lyricsData && !file) {
        //         return (
        //             <div className="d-flex flex-column align-items-center justify-content-center text-center"
        //                 style={{ height: '100%', padding: '10px' }}>
        //                 <div className="mb-2">
        //                     <i className="bi bi-music-note-list" style={{ fontSize: '24px', color: '#4A5568' }}></i>
        //                 </div>
        //                 <span style={{
        //                     fontSize: '12px',
        //                     color: '#4A5568',
        //                     wordBreak: 'break-word'
        //                 }}>
        //                     Existing Lyrics
        //                 </span>
        //                 <span style={{ fontSize: '10px', color: '#48C3F3', marginTop: '4px' }}>
        //                     {files.lyricsData.lines.length} lines
        //                 </span>
        //             </div>
        //         );
        //     }
        // }

        if (file?.type.startsWith('image/') || currentMedia.thumbnail_url) {
            const imageUrl = file ? URL.createObjectURL(file) : currentMedia.thumbnail_url;
            return (
                <img
                    src={imageUrl}
                    alt="Preview"
                    style={{ maxWidth: '100%', maxHeight: '150px', borderRadius: '8px' }}
                />
            );
        }

        return (
            <span>{file?.name || "Current File"}</span>
        );
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'NA';
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    useEffect(() => {
        console.log("Current waypointName:", waypointName);
        console.log("Current waypointResults:", waypointResults);
    }, [waypointName, waypointResults]);

    const handleLanguageToggle = (languageCode) => {
        setEnabledLanguages(prev => ({
            ...prev,
            [languageCode]: !prev[languageCode]
        }));

        // Clear the title when language is disabled
        if (enabledLanguages[languageCode]) {
            const field = SUPPORTED_LANGUAGES.find(l => l.code === languageCode)?.field;
            if (field) {
                setFormData(prev => ({
                    ...prev,
                    [field]: ''
                }));
            }
        }
    };

    const handleMultilingualTitleChange = (e) => {
        const { name, value } = e.target;

        // Validate length
        if (value.length > 45) {
            toast.error('Title cannot exceed 45 characters');
            return;
        }

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateTitles = () => {
        // All 4 titles are now required
        const requiredLanguages = ['en', 'hi', 'mr', 'gu'];

        for (const langCode of requiredLanguages) {
            const field = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.field;
            if (!formData[field]?.trim() || formData[field].trim().length < 3) {
                const langName = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.name;
                toast.error(`${langName} title is required (minimum 3 characters)`);
                return false;
            }
        }
        return true;
    };

    const validateDescriptions = () => {
        // Only validate descriptions for ENABLED languages
        for (const langCode of Object.keys(enabledLanguages)) {
            if (enabledLanguages[langCode]) {  // ← Only check enabled languages
                if (!descriptionByLanguage[langCode]?.trim() || descriptionByLanguage[langCode].trim().length < 10) {
                    const langName = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.name;
                    toast.error(`${langName} description is required (minimum 10 characters)`);
                    return false;
                }
            }
        }
        return true;
    };



    return (
        <Modal show={show} onHide={onHide} size="xl" centered className="edit-artifact-modal"
            style={{
                height: '100vh',  // This sets modal to 90% of viewport height
                display: 'flex',
                alignItems: 'center'
            }}>
            <Modal.Header closeButton className="border-bottom-1 pb-2">
                <Modal.Title>Edit Artifact</Modal.Title>
            </Modal.Header>

            <Modal.Body className="px-4 py-3"
                style={{
                    maxHeight: 'calc(90vh - 200px)', // Subtracting space for header and footer
                    overflowY: 'auto',               // Enables vertical scrolling
                    overflowX: 'hidden',             // Prevents horizontal scrolling
                    scrollbarWidth: 'none',          // For Firefox
                    msOverflowStyle: 'none',         // For Internet Explorer/Edge
                    '&::-webkit-scrollbar': {        // For Chrome, Safari, and newer versions of Edge
                        display: 'none'
                    }
                }}>
                <Form onSubmit={handleSubmit}>
                    {/* Artifact Details Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4 w-100">
                        <div>
                            <span className="text-muted" style={{ fontSize: '14px', fontWeight: 600 }}>Artifact ID - </span>
                            <span style={{ fontSize: '14px', fontWeight: 600 }}>{artifactData?.artifact_id}</span>
                        </div>
                        <div>
                            <span className="text-muted" style={{ fontSize: '14px', fontWeight: 600 }}>Record Creation Date - </span>
                            <span style={{ fontSize: '14px', fontWeight: 600 }}>{formatDate(artifactData?.created_at)}</span>
                        </div>
                        <div>
                            <span className="text-muted" style={{ fontSize: '14px', fontWeight: 600 }}>Last Updated Date - </span>
                            <span style={{ fontSize: '14px', fontWeight: 600 }}>{formatDate(artifactData?.last_updated_at)}</span>
                        </div>
                    </div>

                    {/* Basics Section */}
                    <div className="mb-4">
                        <h6 className="text-primary mb-4" style={{ fontSize: '16px', color: '#6366F1' }}>Basics</h6>

                        {/* Form fields */}
                        <div className="row mb-3">
                            {/* Artifact Type */}
                            <div className="col-3 pe-2">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Artifact Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="artifactType"
                                        value={formData.artifactType}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    >
                                        <option value="" hidden>Select artifact</option>
                                        <option value="TEXT_LITERATURE">Read</option>
                                        <option value="AUDIO_ORALS">Listen</option>
                                        <option value="LONG_VIDEOS">Watch{'(Long Videos)'}</option>
                                        <option value="SHORTS_REELS">Watch{'(Shorts or Reels)'}</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            {/* Status */}
                            <div className="col-3 px-2">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Status <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    >
                                        <option value="" hidden>Select status</option>
                                        <option value="NEW">New</option>
                                        <option value="ACTIVE">Active</option>
                                        <option value="ARCHIVED">Archived</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            {/* Select Content Languages */}
                            <div className="col-3 px-2">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Select Content Languages <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr',
                                        gap: '8px',
                                        padding: '10px',
                                        backgroundColor: '#FFFFFF'
                                    }}>
                                        {SUPPORTED_LANGUAGES.map(lang => (
                                            <Form.Check
                                                key={lang.code}
                                                type="checkbox"
                                                id={`lang-${lang.code}`}
                                                label={lang.name}
                                                checked={enabledLanguages[lang.code]}
                                                onChange={() => handleLanguageToggle(lang.code)}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500'
                                                }}
                                            />
                                        ))}
                                    </div>
                                </Form.Group>
                            </div>

                            {/* Category */}
                            <div className="col-3 ps-2">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Category <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="category"
                                        value={formData.category}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    >
                                        <option value="" hidden>Select category</option>
                                        {formData.artifactType === 'TEXT_LITERATURE' && (
                                            <>
                                                <option value="13">Ebooks</option>
                                                <option value="10">About Teerthas</option>
                                                <option value="18">Blogs & Research</option>
                                                <option value="17">Pooja/Havan Vidhis</option>
                                                <option value="12">Divine Quotes</option>
                                                <option value="19">Mantras</option>
                                                <option value="20">Aartis</option>
                                            </>
                                        )}
                                        {formData.artifactType === 'AUDIO_ORALS' && (
                                            <>
                                                <option value="21">Mantras & Chants</option>
                                                <option value="22">Stotra Recitations</option>
                                                <option value="24">Aarti & Daily Rituals</option>
                                                <option value="25">Discourses & Pravachans</option>
                                                <option value="28">Audio Books & Podcasts</option>
                                                <option value="23">Bhajans</option>
                                            </>
                                        )}
                                        {(formData.artifactType === 'LONG_VIDEOS' || formData.artifactType === 'SHORTS_REELS') && (
                                            <>
                                                <option value="1">Discourses</option>
                                                <option value="2">Satsangs & Q&A</option>
                                                <option value="3">Spiritual Experiences</option>
                                                <option value="4">Life & Well-Being</option>
                                                <option value="5">Divine Moments</option>
                                                <option value="6">Guided Practices</option>
                                                <option value="7">Mantra Chanting</option>
                                                <option value="8">Scriptural Teachings</option>
                                                <option value="9">Parikrama Snippets</option>
                                            </>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Title Inputs Section - All 4 in one horizontal line */}
                        {/* Update the title inputs to have better spacing */}
                        <div className="row mb-3">
                            <div className="col-12">
                                <Form.Label className="mb-3" style={{ color: '#4A5568', fontWeight: '500' }}>
                                    Artifact Title <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="row">
                                    {SUPPORTED_LANGUAGES.map(lang => (
                                        <div key={lang.code} className="col-3">
                                            <Form.Group>
                                                <Form.Label className="mb-2" style={{
                                                    // color: enabledLanguages[lang.code] ? '#4A5568' : '#9CA3AF',  // ❌ REMOVE THIS
                                                    color: '#4A5568',  // ✅ Always same color
                                                    fontWeight: '500',
                                                    fontSize: '14px'
                                                }}>
                                                    {lang.name} Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        name={lang.field}
                                                        placeholder={`Enter Title in ${lang.name}`}
                                                        value={formData[lang.field] || ''}
                                                        onChange={handleMultilingualTitleChange}
                                                        disabled={false}  // ✅ Always enabled
                                                        style={{
                                                            height: '50px',
                                                            paddingRight: '50px',
                                                            border: '1px solid #E2E8F0',
                                                            backgroundColor: '#FFFFFF',  // ✅ Always white
                                                            color: '#1A202C'  // ✅ Always dark text
                                                        }}
                                                    />
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            bottom: '12px',  // ← ADJUSTED POSITION
                                                            right: '15px',
                                                            fontSize: '11px',
                                                            color: '#6B7280'
                                                        }}
                                                    >
                                                        {(formData[lang.field] || '').length}/30
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Description Section - Full Width Below Titles */}
                        <div className="row mb-3">
                            <div className="col-12">
                                <Form.Label className="mb-3" style={{ color: '#4A5568', fontWeight: '500' }}>
                                    Short Description <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="row">
                                    {SUPPORTED_LANGUAGES.map(lang => (
                                        <div key={lang.code} className="col-6 mb-3">
                                            <Form.Group>
                                                <Form.Label className="mb-2" style={{
                                                    color: '#4A5568',
                                                    fontWeight: '500',
                                                    fontSize: '14px'
                                                }}>
                                                    {lang.name} Description
                                                    {((formData.artifactType === 'LONG_VIDEOS' || formData.artifactType === 'SHORTS_REELS') || enabledLanguages[lang.code]) &&
                                                        <span className="text-danger">*</span>
                                                    }
                                                </Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        as="textarea"
                                                        name={lang.descField}
                                                        placeholder={`Enter Description in ${lang.name}`}
                                                        value={descriptionByLanguage[lang.code] || ''}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            if (value.length > 300) {
                                                                toast.error('Description cannot exceed 300 characters');
                                                                return;
                                                            }
                                                            setDescriptionByLanguage(prev => ({
                                                                ...prev,
                                                                [lang.code]: value
                                                            }));
                                                        }}
                                                        style={{
                                                            height: '100px',
                                                            border: '1px solid #E2E8F0',
                                                            backgroundColor: '#FFFFFF',
                                                            resize: 'none',
                                                        }}
                                                    />
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            bottom: '8px',
                                                            right: '15px',
                                                            fontSize: '12px',
                                                            color: '#6B7280'
                                                        }}
                                                    >
                                                        {(descriptionByLanguage[lang.code] || '').length}/300
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Conditional Content Based on Artifact Type */}
                        {formData.artifactType === 'TEXT_LITERATURE' ? (
                            /* Text Literature: Show Multilingual Editor or Ebook R2 Links */
                            <>
                                {Number(formData.category) === 13 ? (
                                    /* Ebooks: Show R2 link inputs per enabled language */
                                    <div className="row mb-4 mt-4">
                                        {SUPPORTED_LANGUAGES.filter(lang => enabledLanguages[lang.code]).map(lang => (
                                            <div key={lang.code} className="col-3 pe-2 mb-3">
                                                <Form.Group>
                                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                        {lang.name} PDF Link <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Paste R2 link for ${lang.name}`}
                                                        value={currentMediaByLanguage[lang.code]?.main_url || ''}
                                                        onChange={(e) => setCurrentMediaByLanguage(prev => ({
                                                            ...prev,
                                                            [lang.code]: { ...prev[lang.code], main_url: e.target.value }
                                                        }))}
                                                        style={{
                                                            height: '44px',
                                                            border: '1px solid #E2E8F0',
                                                            backgroundColor: '#FFFFFF'
                                                        }}
                                                    />
                                                </Form.Group>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    /* Other text literature: Show Multilingual Editor */
                                    <div className="row mb-4">
                                        <div className="col-12">
                                            <Form.Group>
                                                <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                                                    <Form.Label style={{ color: '#4A5568', fontWeight: '500' }}>
                                                        Text Literature <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() => setShowPreview(true)}
                                                        style={{ fontSize: '12px' }}
                                                    >
                                                        Preview
                                                    </Button>
                                                </div>
                                                <div className="mb-2">
                                                    <div className="d-flex gap-1" style={{ flexWrap: 'wrap' }}>
                                                        {SUPPORTED_LANGUAGES.map(lang => (
                                                            <button
                                                                key={lang.code}
                                                                type="button"
                                                                className={`btn btn-sm ${activeContentTab === lang.code ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                onClick={() => setActiveContentTab(lang.code)}
                                                                style={{
                                                                    fontSize: '12px',
                                                                    padding: '6px 12px',
                                                                    minWidth: '80px'
                                                                }}
                                                            >
                                                                {lang.name}
                                                                {contentByLanguage[lang.code]?.trim() && (
                                                                    <span style={{ color: 'green', marginLeft: '4px' }}>•</span>
                                                                )}
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>
                                                {isEditorReady ? (
                                                    <SunEditor
                                                        key={`${artifactData?.artifact_id}-${activeContentTab}`}
                                                        setContents={contentByLanguage[activeContentTab]}
                                                        onChange={(content) => {
                                                            setContentByLanguage(prev => ({
                                                                ...prev,
                                                                [activeContentTab]: content
                                                            }));
                                                            if (activeContentTab === 'en') {
                                                                setHtmlContent(content);
                                                            }
                                                        }}
                                                        setOptions={{
                                                            ...sunEditorOptions,
                                                            resizingBar: false,
                                                            showPathLabel: false,
                                                            mode: 'classic'
                                                        }}
                                                    />
                                                ) : (
                                                    <div style={{ height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #E2E8F0', borderRadius: '8px', backgroundColor: '#F7FAFC' }}>
                                                        <span style={{ color: '#9CA3AF' }}>Loading editor...</span>
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </div>
                                    </div>
                                )}

                                {/* Thumbnail Upload Only for Text Literature */}
                                <div className="row mb-4">
                                    <div className="col-3">
                                        <Form.Group>
                                            <Form.Label>Upload Thumbnail</Form.Label>
                                            <input
                                                type="file"
                                                id="thumbnailFile"
                                                onChange={(e) => handleFileChange(e, 'thumbnail')}
                                                style={{ display: 'none' }}
                                            />
                                            <div
                                                className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                style={{
                                                    height: '150px',
                                                    backgroundColor: '#FFFFFF',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => triggerFileInput('thumbnailFile')}
                                            >
                                                {currentMedia.thumbnail_url ? (
                                                    <img
                                                        src={currentMedia.thumbnail_url}
                                                        alt="Thumbnail"
                                                        style={{ maxHeight: '100%', maxWidth: '100%' }}
                                                    />
                                                ) : (
                                                    renderFilePreview(files.thumbnail, 'thumbnail')
                                                )}
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </>
                        ) : (
                            /* Other Artifact Types: Show Multilingual Upload */
                            <div className="row mt-2 mb-4">
                                {/* Show warning if text content is present but shouldn't be */}
                                {/* {(contentByLanguage.en?.trim() && contentByLanguage.en.trim() !== '<p><br></p>') && (
                                    <div className="alert alert-warning mb-3" style={{ fontSize: '14px' }}>
                                        <strong>Warning:</strong> File-based artifacts should not contain written content.
                                        Please clear the text content or change to Text Literature type.
                                    </div>
                                )} */}
                                {SUPPORTED_LANGUAGES.map(lang => (
                                    <div key={lang.code} className="col-3 pe-2">
                                        <Form.Group>
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                {lang.name} Upload {lang.code === 'en' && <span className="text-danger">*</span>}
                                                {filesByLanguage[lang.code]?.main && (
                                                    <span style={{ color: 'green', marginLeft: '4px' }}>•</span>
                                                )}
                                            </Form.Label>
                                            <input
                                                type="file"
                                                id={`mainFile_${lang.code}`}
                                                onChange={(e) => handleMultilingualFileChange(e, 'main', lang.code)}
                                                style={{ display: 'none' }}
                                            />
                                            <div
                                                className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                style={{
                                                    height: '150px',
                                                    backgroundColor: enabledLanguages[lang.code] ? '#FFFFFF' : '#F7FAFC',  // ← ADD
                                                    cursor: enabledLanguages[lang.code] ? 'pointer' : 'not-allowed',        // ← CHANGE
                                                    opacity: enabledLanguages[lang.code] ? 1 : 0.5
                                                }}
                                                onClick={() => enabledLanguages[lang.code] && triggerFileInput(`mainFile_${lang.code}`)}
                                            >
                                                {renderMultilingualFilePreview(filesByLanguage[lang.code]?.main, 'main', lang.code)}
                                            </div>
                                        </Form.Group>
                                    </div>
                                ))}
                                <div className="col-3 ps-2">
                                    <Form.Group>
                                        <Form.Label>Upload Thumbnail</Form.Label>
                                        <input
                                            type="file"
                                            id="thumbnailFile"
                                            onChange={(e) => handleFileChange(e, 'thumbnail')}
                                            style={{ display: 'none' }}
                                        />
                                        <div
                                            onClick={() => triggerFileInput('thumbnailFile')}
                                            className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                            style={{
                                                height: '150px',
                                                backgroundColor: '#FFFFFF',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {currentMedia.thumbnail_url ? (
                                                <img
                                                    src={currentMedia.thumbnail_url}
                                                    alt="Thumbnail"
                                                    style={{ maxHeight: '100%', maxWidth: '100%' }}
                                                />
                                            ) : (
                                                renderFilePreview(files.thumbnail, 'thumbnail')
                                            )}
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Additional Details Section */}
                    <div className="mb-4">
                        <h6 className="text-primary mb-4" style={{ fontSize: '16px', color: '#6366F1' }}>Additional Details</h6>

                        {/* First row: Related Waypoints, Author/Speaker, Language */}
                        <div className="row mb-3 align-items-center">
                            <div className="col-12">
                                <div className="row">
                                    {/* Has Container Checkbox */}
                                    {formData.artifactType === 'TEXT_LITERATURE' && formData.category === 19 && (
                                        <div className="col-3">
                                            <Form.Group>
                                                <Form.Check
                                                    type="checkbox"
                                                    id="hasContainer"
                                                    label="Has a Container"
                                                    checked={hasContainer}
                                                    onChange={handleContainerCheckboxChange}
                                                    style={{
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        color: '#4A5568'
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                    )}
                                    {/* Has Read Checkbox */}
                                    {(formData.artifactType === 'LONG_VIDEOS' || formData.artifactType === 'AUDIO_ORALS') && <div className="col-3">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                id="hasContainer"
                                                label="Has Read Artifact"
                                                checked={readFlag}
                                                onChange={(e) => { setReadFlag(e.target.checked); if (!e.target.checked) setReadSearch(''); }}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#4A5568'
                                                }}
                                            />
                                        </Form.Group>
                                    </div>}
                                    {/* Has Listen Checkbox */}
                                    {(formData.artifactType === 'TEXT_LITERATURE' || formData.artifactType === 'LONG_VIDEOS') && <div className="col-3">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                id="hasContainer"
                                                label="Has Listen Artifact"
                                                checked={listenFlag}
                                                onChange={(e) => { setListenFlag(e.target.checked); if (!e.target.checked) setListenSearch(''); }}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#4A5568'
                                                }}
                                            />
                                        </Form.Group>
                                    </div>}
                                    {/* Has Watch Checkbox */}
                                    {(formData.artifactType === 'TEXT_LITERATURE' || formData.artifactType === 'AUDIO_ORALS') && <div className="col-3">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                id="hasContainer"
                                                label="Has Watch Artifact"
                                                checked={watchFlag}
                                                onChange={(e) => { setWatchFlag(e.target.checked); if (!e.target.checked) setWatchSearch(''); }}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#4A5568'
                                                }}
                                            />
                                        </Form.Group>
                                    </div>}


                                </div>
                            </div>

                            {/* Author/Speaker */}
                            {/* <div className="col-3" ref={authorInputContainerRef} style={{ position: 'relative' }}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        {formData.artifactType === 'TEXT_LITERATURE' ? 'Author' : 'Author/Speaker'} <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="author"
                                        placeholder={`Enter ${formData.artifactType === 'TEXT_LITERATURE' ? 'Author' : 'Author/Speaker'}`}
                                        value={formData.author || ''}
                                        onChange={handleInputChange}
                                        onFocus={handleAuthorInputFocus}
                                        onBlur={handleAuthorInputBlur}
                                        autoComplete="off" // Prevent browser's autocomplete
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    />
                                    {authorsError && (
                                        <div className="position-absolute mt-1 p-2 bg-white border rounded shadow-sm w-100 text-danger" style={{ zIndex: 1000 }}>
                                            Error: {authorsError}
                                        </div>
                                    )}
                                    
                                    {showAuthorSuggestions && !authorsError && (
                                        <div
                                            className="position-absolute mt-1 bg-white border rounded shadow-sm w-100"
                                            style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000 }}
                                        >
                                            {filteredAuthors.length > 0 ? (
                                                <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                                    {filteredAuthors.map((author, index) => (
                                                        <li
                                                            key={index} 
                                                            onClick={() => handleAuthorSelect(author)}
                                                            style={{
                                                                padding: '8px 12px',
                                                                cursor: 'pointer',
                                                                borderBottom: '1px solid #eee'
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                                        >
                                                            {author}
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <div style={{ padding: '8px 12px', color: '#666' }}>
                                                    No matching authors. You can add "{formData.author}"
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Form.Group>
                            </div> */}

                            {/* Language */}
                            {/* <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Language <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="languages"
                                        value={formData.languages || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    >
                                        <option value="" hidden>Select Language</option>
                                        <option value="english">English</option>
                                        <option value="hindi">Hindi</option>
                                        <option value="marathi">Marathi</option>
                                        <option value="gujarati">Gujarati</option>
                                        <option value="sanskrit">Sanskrit</option>
                                    </Form.Select>
                                </Form.Group>
                            </div> */}
                        </div>

                        <div className="row mb-3">


{readFlag && (
    <div className="row mb-3">
        <div className="col-3">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Select Read Artifact <span className="text-danger">*</span>
                </Form.Label>
                <div className="position-relative">
                    <Form.Control
                        type="text"
                        placeholder="Search Read Artifact"
                        value={readSearch}
                        onChange={(e) => setReadSearch(e.target.value)}
                        style={{ height: '44px', paddingRight: '35px', border: '1px solid #E2E8F0' }}
                    />
                    <img src={Search} alt="search" className="position-absolute"
                        style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', zIndex: 2 }}
                    />
                    {readSearch.length > 0 && (
                        <div className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                            {allReadArtifacts
                                .filter(a => a.title?.toLowerCase().includes(readSearch.toLowerCase()))
                                .map(artifact => (
                                    <div key={artifact.artifact_id} className="p-2"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedReadId(artifact.artifact_id);
                                            setSelectedReadArtifact(artifact);
                                            setReadSearch('');
                                        }}
                                    >
                                        {artifact.title}
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
            </Form.Group>
        </div>
        <div className="col-6">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Selected Read Artifact
                </Form.Label>
                <div style={{ minHeight: '44px', border: '1px solid #E2E8F0', borderRadius: '0.375rem', padding: '8px 12px', backgroundColor: '#FFFFFF' }}>
                    {selectedReadArtifact && (
                        <span className="d-inline-flex align-items-center"
                            style={{ backgroundColor: '#6366F1', color: 'white', padding: '4px 10px', borderRadius: '6px', fontSize: '14px' }}
                        >
                            {selectedReadArtifact.title}
                            <button onClick={(e) => { e.preventDefault(); setSelectedReadId(''); setSelectedReadArtifact(null); }}
                                className="ms-2 border-0 bg-transparent text-white" style={{ cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}>
                                ×
                            </button>
                        </span>
                    )}
                </div>
            </Form.Group>
        </div>
    </div>
)}

{listenFlag && (
    <div className="row mb-3">
        <div className="col-3">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Select Listen Artifact <span className="text-danger">*</span>
                </Form.Label>
                <div className="position-relative">
                    <Form.Control
                        type="text"
                        placeholder="Search Listen Artifact"
                        value={listenSearch}
                        onChange={(e) => setListenSearch(e.target.value)}
                        style={{ height: '44px', paddingRight: '35px', border: '1px solid #E2E8F0' }}
                    />
                    <img src={Search} alt="search" className="position-absolute"
                        style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', zIndex: 2 }}
                    />
                    {listenSearch.length > 0 && (
                        <div className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                            {allListenArtifacts
                                .filter(a => a.title?.toLowerCase().includes(listenSearch.toLowerCase()))
                                .map(artifact => (
                                    <div key={artifact.artifact_id} className="p-2"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedListenId(artifact.artifact_id);
                                            setSelectedListenArtifact(artifact);
                                            setListenSearch('');
                                        }}
                                    >
                                        {artifact.title}
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
            </Form.Group>
        </div>
        <div className="col-6">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Selected Listen Artifact
                </Form.Label>
                <div style={{ minHeight: '44px', border: '1px solid #E2E8F0', borderRadius: '0.375rem', padding: '8px 12px', backgroundColor: '#FFFFFF' }}>
                    {selectedListenArtifact && (
                        <span className="d-inline-flex align-items-center"
                            style={{ backgroundColor: '#6366F1', color: 'white', padding: '4px 10px', borderRadius: '6px', fontSize: '14px' }}
                        >
                            {selectedListenArtifact.title}
                            <button onClick={(e) => { e.preventDefault(); setSelectedListenId(''); setSelectedListenArtifact(null); }}
                                className="ms-2 border-0 bg-transparent text-white" style={{ cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}>
                                ×
                            </button>
                        </span>
                    )}
                </div>
            </Form.Group>
        </div>
    </div>
)}

{watchFlag && (
    <div className="row mb-3">
        <div className="col-3">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Select Watch Artifact <span className="text-danger">*</span>
                </Form.Label>
                <div className="position-relative">
                    <Form.Control
                        type="text"
                        placeholder="Search Watch Artifact"
                        value={watchSearch}
                        onChange={(e) => setWatchSearch(e.target.value)}
                        style={{ height: '44px', paddingRight: '35px', border: '1px solid #E2E8F0' }}
                    />
                    <img src={Search} alt="search" className="position-absolute"
                        style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', zIndex: 2 }}
                    />
                    {watchSearch.length > 0 && (
                        <div className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                            {allWatchArtifacts
                                .filter(a => a.title?.toLowerCase().includes(watchSearch.toLowerCase()))
                                .map(artifact => (
                                    <div key={artifact.artifact_id} className="p-2"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedWatchId(artifact.artifact_id);
                                            setSelectedWatchArtifact(artifact);
                                            setWatchSearch('');
                                        }}
                                    >
                                        {artifact.title}
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
            </Form.Group>
        </div>
        <div className="col-6">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Selected Watch Artifact
                </Form.Label>
                <div style={{ minHeight: '44px', border: '1px solid #E2E8F0', borderRadius: '0.375rem', padding: '8px 12px', backgroundColor: '#FFFFFF' }}>
                    {selectedWatchArtifact && (
                        <span className="d-inline-flex align-items-center"
                            style={{ backgroundColor: '#6366F1', color: 'white', padding: '4px 10px', borderRadius: '6px', fontSize: '14px' }}
                        >
                            {selectedWatchArtifact.title}
                            <button onClick={(e) => { e.preventDefault(); setSelectedWatchId(''); setSelectedWatchArtifact(null); }}
                                className="ms-2 border-0 bg-transparent text-white" style={{ cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}>
                                ×
                            </button>
                        </span>
                    )}
                </div>
            </Form.Group>
        </div>
    </div>
)}

                        </div>


                        {/* Container Section - Show only for Text Literature + Mantras */}
                        {formData.artifactType === 'TEXT_LITERATURE' && formData.category === 19 && (
                            <>
                                {/* {console.log('Container UI Visible:', {
                                    artifactType: formData.artifactType,
                                    category: formData.category,
                                    categoryType: typeof formData.category,
                                    hasContainer: hasContainer,
                                    selectedContainerId: selectedContainerId
                                })} */}
                                {/* Has Container Checkbox */}


                                {/* Container Options - Show when checkbox is checked */}
                                {hasContainer && (
                                    <div className="row mb-3">
                                        {/* Radio Buttons */}
                                        <div className="col-12 mb-3">
                                            <Form.Group>
                                                <div className="d-flex gap-4">
                                                    <Form.Check
                                                        type="radio"
                                                        id="containerExisting"
                                                        name="containerOption"
                                                        value="EXISTING"
                                                        label="Existing Container"
                                                        checked={containerOption === 'EXISTING'}
                                                        onChange={handleContainerOptionChange}
                                                        style={{ fontSize: '14px', fontWeight: '500' }}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        id="containerNew"
                                                        name="containerOption"
                                                        value="NEW"
                                                        label="New Container"
                                                        checked={containerOption === 'NEW'}
                                                        onChange={handleContainerOptionChange}
                                                        style={{ fontSize: '14px', fontWeight: '500' }}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </div>
                                        {/* Existing Container Multi-Select */}
                                        {containerOption === 'EXISTING' && (
                                            <>
                                                {/* Search Container */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Search Containers <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <div className="position-relative">
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Search Containers"
                                                                value={searchContainer}
                                                                onChange={(e) => setSearchContainer(e.target.value)}
                                                                style={{
                                                                    height: '44px',
                                                                    paddingRight: '35px',
                                                                    paddingLeft: '12px',
                                                                    border: '1px solid #E2E8F0',
                                                                    backgroundColor: '#FFFFFF'
                                                                }}
                                                            />
                                                            <img
                                                                src={Search}
                                                                alt="search"
                                                                className="position-absolute"
                                                                style={{
                                                                    right: '10px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    zIndex: 2
                                                                }}
                                                            />
                                                            {/* Container Search Results Dropdown */}
                                                            {searchContainer.length > 0 && allContainers.filter((container) =>
                                                                container?.container_name?.toLowerCase().includes(searchContainer.toLowerCase())
                                                            ).length > 0 && (
                                                                    <div
                                                                        className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                                        style={{
                                                                            zIndex: 1000,
                                                                            maxHeight: '200px',
                                                                            overflowY: 'auto'
                                                                        }}
                                                                    >
                                                                        {allContainers.filter((container) =>
                                                                            container?.container_name?.toLowerCase().includes(searchContainer.toLowerCase())
                                                                        ).map(container => {
                                                                            const isSelected = selectedContainers.some(c => c.container_id === container.container_id);
                                                                            if (!isSelected) {
                                                                                return (
                                                                                    <div
                                                                                        key={container.container_id}
                                                                                        className="p-2 cursor-pointer hover:bg-gray-100 d-flex align-items-center gap-2"
                                                                                        onClick={() => handleContainerSelect(container)}
                                                                                        style={{ cursor: 'pointer' }}
                                                                                    >
                                                                                        {container.container_thumbnail_url && (
                                                                                            <img
                                                                                                src={container.container_thumbnail_url}
                                                                                                alt=""
                                                                                                style={{
                                                                                                    width: '30px',
                                                                                                    height: '30px',
                                                                                                    objectFit: 'cover',
                                                                                                    borderRadius: '4px'
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                        {container.container_name}
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                                {/* Selected Containers */}
                                                <div className="col-6">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Selected Containers
                                                        </Form.Label>
                                                        <div className="position-relative">
                                                            <div
                                                                style={{
                                                                    minHeight: '100px',
                                                                    maxHeight: '100px',
                                                                    height: 'auto',
                                                                    border: '1px solid #E2E8F0',
                                                                    backgroundColor: '#FFFFFF',
                                                                    borderRadius: '0.375rem',
                                                                    padding: '12px',
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    {selectedContainers.map((container) => (
                                                                        <span
                                                                            key={container.container_id}
                                                                            className="d-inline-flex align-items-center"
                                                                            style={{
                                                                                backgroundColor: '#6366F1',
                                                                                color: 'white',
                                                                                padding: '6px 12px',
                                                                                borderRadius: '6px',
                                                                                fontSize: '14px',
                                                                                marginBottom: '4px'
                                                                            }}
                                                                        >
                                                                            {container.container_name}
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleContainerRemove(container.container_id);
                                                                                }}
                                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                                style={{
                                                                                    padding: '0',
                                                                                    lineHeight: 1,
                                                                                    fontSize: '18px',
                                                                                    fontWeight: 'bold',
                                                                                    opacity: 0.8,
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                ×
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                        {/* New Container Fields */}
                                        {containerOption === 'NEW' && (
                                            <>
                                                {/* Container Name (English) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (English) <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Container Name"
                                                            value={newContainerName}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 255) {
                                                                    setNewContainerName(value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Hindi) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Hindi)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="कंटेनर नाम दर्ज करें"
                                                            value={newContainerNameHin}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameHin(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Marathi) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Marathi)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="कंटेनर नाव प्रविष्ट करा"
                                                            value={newContainerNameMar}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameMar(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Gujarati) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Gujarati)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="કન્ટેનર નામ દાખલ કરો"
                                                            value={newContainerNameGuj}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameGuj(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Thumbnail Upload */}
                                                <div className="col-3 mt-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Thumbnail <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <input
                                                            type="file"
                                                            id="containerThumbnailFile"
                                                            accept=".jpg,.jpeg,.png,.gif"
                                                            onChange={handleContainerThumbnailChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <div
                                                            className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                            style={{
                                                                height: '100px',
                                                                backgroundColor: '#FFFFFF',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => document.getElementById('containerThumbnailFile').click()}
                                                        >
                                                            {containerThumbnail ? (
                                                                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                                                                    <img
                                                                        src={URL.createObjectURL(containerThumbnail)}
                                                                        alt="Container Thumbnail"
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            borderRadius: '8px'
                                                                        }}
                                                                    />
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        bottom: '0',
                                                                        left: '0',
                                                                        right: '0',
                                                                        padding: '4px',
                                                                        background: 'rgba(0, 0, 0, 0.6)',
                                                                        color: 'white',
                                                                        fontSize: '10px',
                                                                        textAlign: 'center'
                                                                    }}>
                                                                        {containerThumbnail.name}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="text-center">
                                                                    <span style={{ fontSize: '24px', color: '#A0AEC0' }}>+</span>
                                                                    <p style={{ fontSize: '10px', color: '#718096', margin: '0' }}>
                                                                        Upload JPG, PNG, GIF<br />(Max 3MB)
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            </>
                        )}

                        {/* Listen Container Section - Show only for Audio + Mantras and chants */}
                        {formData.artifactType === 'AUDIO_ORALS' && formData.category === 21 && (
                            <>
                                {/* Has Container Checkbox */}
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                id="hasListenContainer"
                                                label="Has a Container"
                                                checked={hasContainer}
                                                onChange={handleContainerCheckboxChange}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#4A5568'
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                                {/* Container Options - Show when checkbox is checked */}
                                {hasContainer && (
                                    <div className="row mb-3">
                                        {/* Radio Buttons */}
                                        <div className="col-12 mb-3">
                                            <Form.Group>
                                                <div className="d-flex gap-4">
                                                    <Form.Check
                                                        type="radio"
                                                        id="listenContainerExisting"
                                                        name="listenContainerOption"
                                                        value="EXISTING"
                                                        label="Existing Container"
                                                        checked={containerOption === 'EXISTING'}
                                                        onChange={handleContainerOptionChange}
                                                        style={{ fontSize: '14px', fontWeight: '500' }}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        id="listenContainerNew"
                                                        name="listenContainerOption"
                                                        value="NEW"
                                                        label="New Container"
                                                        checked={containerOption === 'NEW'}
                                                        onChange={handleContainerOptionChange}
                                                        style={{ fontSize: '14px', fontWeight: '500' }}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </div>
                                        {/* Existing Container Multi-Select */}
                                        {containerOption === 'EXISTING' && (
                                            <>
                                                {/* Search Container */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Search Containers <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <div className="position-relative">
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Search Containers"
                                                                value={searchListenContainer}
                                                                onChange={(e) => setSearchListenContainer(e.target.value)}
                                                                style={{
                                                                    height: '44px',
                                                                    paddingRight: '35px',
                                                                    paddingLeft: '12px',
                                                                    border: '1px solid #E2E8F0',
                                                                    backgroundColor: '#FFFFFF'
                                                                }}
                                                            />
                                                            <img
                                                                src={Search}
                                                                alt="search"
                                                                className="position-absolute"
                                                                style={{
                                                                    right: '10px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    zIndex: 2
                                                                }}
                                                            />
                                                            {/* Container Search Results Dropdown */}
                                                            {searchListenContainer.length > 0 && allListenContainers.filter((container) =>
                                                                container?.container_name?.toLowerCase().includes(searchListenContainer.toLowerCase())
                                                            ).length > 0 && (
                                                                    <div
                                                                        className="position-absolute w-100 bg-white border rounded shadow-sm"
                                                                        style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 10, top: '100%' }}
                                                                    >
                                                                        {allListenContainers.filter((container) =>
                                                                            container?.container_name?.toLowerCase().includes(searchListenContainer.toLowerCase())
                                                                        ).map((container) => {
                                                                            const isSelected = selectedListenContainers.some(c => c.container_id === container.container_id);
                                                                            if (!isSelected) {
                                                                                return (
                                                                                    <div
                                                                                        key={container.container_id}
                                                                                        className="p-2 cursor-pointer hover:bg-gray-100 d-flex align-items-center gap-2"
                                                                                        onClick={() => handleListenContainerSelect(container)}
                                                                                        style={{ cursor: 'pointer' }}
                                                                                    >
                                                                                        {container.container_thumbnail_url && (
                                                                                            <img
                                                                                                src={container.container_thumbnail_url}
                                                                                                alt=""
                                                                                                style={{
                                                                                                    width: '30px',
                                                                                                    height: '30px',
                                                                                                    objectFit: 'cover',
                                                                                                    borderRadius: '4px'
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                        {container.container_name}
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                                {/* Selected Containers */}
                                                <div className="col-6">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Selected Containers
                                                        </Form.Label>
                                                        <div className="position-relative">
                                                            <div
                                                                style={{
                                                                    minHeight: '100px',
                                                                    maxHeight: '100px',
                                                                    height: 'auto',
                                                                    border: '1px solid #E2E8F0',
                                                                    backgroundColor: '#FFFFFF',
                                                                    borderRadius: '0.375rem',
                                                                    padding: '12px',
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    {selectedListenContainers.map((container) => (
                                                                        <span
                                                                            key={container.container_id}
                                                                            className="d-inline-flex align-items-center"
                                                                            style={{
                                                                                backgroundColor: '#6366F1',
                                                                                color: 'white',
                                                                                padding: '6px 12px',
                                                                                borderRadius: '6px',
                                                                                fontSize: '14px',
                                                                                marginBottom: '4px'
                                                                            }}
                                                                        >
                                                                            {container.container_name}
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleListenContainerRemove(container.container_id);
                                                                                }}
                                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                                style={{
                                                                                    padding: '0',
                                                                                    lineHeight: 1,
                                                                                    fontSize: '18px',
                                                                                    fontWeight: 'bold',
                                                                                    opacity: 0.8,
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                ×
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                        {/* New Container Fields */}
                                        {containerOption === 'NEW' && (
                                            <>
                                                {/* Container Name (English) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (English) <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Container Name"
                                                            value={newContainerName}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 255) {
                                                                    setNewContainerName(value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Hindi) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Hindi)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="कंटेनर नाम दर्ज करें"
                                                            value={newContainerNameHin}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameHin(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Marathi) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Marathi)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="कंटेनर नाव प्रविष्ट करा"
                                                            value={newContainerNameMar}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameMar(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Gujarati) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Gujarati)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="કન્ટેનર નામ દાખલ કરો"
                                                            value={newContainerNameGuj}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameGuj(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Thumbnail Upload */}
                                                <div className="col-3 mt-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Thumbnail <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <input
                                                            type="file"
                                                            id="listenContainerThumbnailFile"
                                                            accept=".jpg,.jpeg,.png,.gif"
                                                            onChange={handleContainerThumbnailChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <div
                                                            className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                            style={{
                                                                height: '100px',
                                                                backgroundColor: '#FFFFFF',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => document.getElementById('listenContainerThumbnailFile').click()}
                                                        >
                                                            {containerThumbnail ? (
                                                                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                                                                    <img
                                                                        src={URL.createObjectURL(containerThumbnail)}
                                                                        alt="Container Thumbnail"
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            borderRadius: '8px'
                                                                        }}
                                                                    />
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        bottom: '0',
                                                                        left: '0',
                                                                        right: '0',
                                                                        padding: '4px',
                                                                        background: 'rgba(0, 0, 0, 0.6)',
                                                                        color: 'white',
                                                                        fontSize: '10px',
                                                                        textAlign: 'center'
                                                                    }}>
                                                                        {containerThumbnail.name}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="text-center">
                                                                    <span style={{ fontSize: '24px', color: '#A0AEC0' }}>+</span>
                                                                    <p style={{ fontSize: '10px', color: '#718096', margin: '0' }}>
                                                                        Upload JPG, PNG, GIF<br />(Max 3MB)
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            </>
                        )}


                        {/* Second Row: Parikramas and Selected Parikramas */}
                        <div className="row mb-3">
                            {/* Related Parikramas */}
                            <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Related Parikramas
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            name="relatedJourney"
                                            placeholder="Search Related Parikramas"
                                            value={searchJourney}
                                            onChange={(item) => {
                                                setSearchJourney(item.target.value)
                                            }}
                                            style={{
                                                height: '44px',
                                                paddingRight: '35px',
                                                paddingLeft: '12px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                        <img
                                            src={Search}
                                            alt="search"
                                            className="position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '16px',
                                                height: '16px',
                                                zIndex: 2
                                            }}
                                        />
                                        {/* Journey Search Results Dropdown */}
                                        {searchJourney.length > 0 && journeyResults.filter((journey) => journey.trip_name.includes(searchJourney)).length > 0 && (
                                            <div
                                                className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                style={{
                                                    zIndex: 1000,
                                                    maxHeight: '200px',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                {journeyResults.filter((journey) => journey.trip_name.includes(searchJourney)).map(journey => {
                                                    const isSelected = selectedJourneys.some(j => j.journey_id === journey.journey_id);
                                                    if (!isSelected) {
                                                        return (
                                                            <div
                                                                key={journey.journey_id}
                                                                className="p-2 cursor-pointer hover:bg-gray-100"
                                                                onClick={() => handleJourneySelect(journey)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {journey.trip_name}
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>
                            </div>

                            {/* Selected Parikramas */}
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Selected Parikramas
                                    </Form.Label>
                                    <div className="position-relative">
                                        <div
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '100px',
                                                height: 'auto',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '0.375rem',
                                                padding: '12px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedJourneys.map((journey) => (
                                                    <span
                                                        key={journey.journey_id}
                                                        className="d-inline-flex align-items-center"
                                                        style={{
                                                            backgroundColor: '#6366F1',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            marginBottom: '4px'
                                                        }}
                                                    >
                                                        {journey.trip_name}
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleJourneyRemove(journey.journey_id);
                                                            }}
                                                            className="ms-2 border-0 bg-transparent text-white"
                                                            style={{
                                                                padding: '0',
                                                                lineHeight: 1,
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                opacity: 0.8,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Second Row: Selected Waypoints and Selected Deities */}
                        <div className="row mb-3">
                            {/* Related Waypoints */}
                            <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Related Teerthas
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            name="relatedWaypoint"
                                            placeholder="Search Related Teerthas"
                                            value={waypointName}
                                            onChange={handleInputChange}
                                            style={{
                                                height: '44px',
                                                paddingRight: '35px',
                                                paddingLeft: '12px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                        <img
                                            src={Search}
                                            alt="search"
                                            className="position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '16px',
                                                height: '16px',
                                                zIndex: 2
                                            }}
                                        />
                                        {/* Search Results Dropdown */}
                                        {waypointResults.length > 0 && (
                                            <div
                                                className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                style={{
                                                    zIndex: 1000,
                                                    maxHeight: '200px',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                {waypointResults.map(waypoint => {
                                                    const isSelected = formData.selectedWaypoints.some(w => w.wpt_id === waypoint.wpt_id);
                                                    if (!isSelected) {
                                                        return (
                                                            <div
                                                                key={waypoint.wpt_id}
                                                                className="p-2 cursor-pointer hover:bg-gray-100"
                                                                onClick={() => handleWaypointSelect(waypoint)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {waypoint.wpt_name}
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>
                            </div>
                            {/* Selected Waypoints */}
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Selected Teerthas
                                    </Form.Label>
                                    <div className="position-relative">
                                        <div
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '100px',
                                                height: 'auto',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '0.375rem',
                                                padding: '12px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <div className="d-flex flex-wrap gap-2">
                                                {formData.selectedWaypoints.map((waypoint) => (
                                                    <span
                                                        key={waypoint.wpt_id}
                                                        className="d-inline-flex align-items-center"
                                                        style={{
                                                            backgroundColor: '#6366F1',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            marginBottom: '4px'
                                                        }}
                                                    >
                                                        {waypoint.wpt_name}
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleWaypointRemove(waypoint.wpt_id);
                                                            }}
                                                            className="ms-2 border-0 bg-transparent text-white"
                                                            style={{
                                                                padding: '0',
                                                                lineHeight: 1,
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                opacity: 0.8,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row mb-3">
                            {/* Related Deities */}
                            <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Related Deities
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            name="relatedDeity"
                                            placeholder="Search Related Deities"
                                            value={searchDeity}
                                            onChange={(item) => {
                                                setSearchDeity(item.target.value)
                                            }}
                                            style={{
                                                height: '44px',
                                                paddingRight: '35px',
                                                paddingLeft: '12px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                        <img
                                            src={Search}
                                            alt="search"
                                            className="position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '16px',
                                                height: '16px',
                                                zIndex: 2
                                            }}
                                        />
                                        {/* Deity Search Results Dropdown */}
                                        {searchDeity.length > 0 && deityResults.filter((deity) => deity.deity_name.includes(searchDeity)).length > 0 && (
                                            <div
                                                className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                style={{
                                                    zIndex: 1000,
                                                    maxHeight: '200px',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                {deityResults.filter((deity) => deity.deity_name.includes(searchDeity)).map(deity => {
                                                    const isSelected = selectedDeities.some(d => d.deity_id === deity.deity_id);
                                                    if (!isSelected) {
                                                        return (
                                                            <div
                                                                key={deity.deity_id}
                                                                className="p-2 cursor-pointer hover:bg-gray-100"
                                                                onClick={() => handleDeitySelect(deity)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {deity.deity_name}
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>
                            </div>

                            {/* Selected Deities */}
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Selected Deities
                                    </Form.Label>
                                    <div className="position-relative">
                                        <div
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '100px',
                                                height: 'auto',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '0.375rem',
                                                padding: '12px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedDeities.map((deity) => (
                                                    <span
                                                        key={deity.deity_id}
                                                        className="d-inline-flex align-items-center"
                                                        style={{
                                                            backgroundColor: '#6366F1',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            marginBottom: '4px'
                                                        }}
                                                    >
                                                        {deity.deity_name}
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleDeityRemove(deity.deity_id);
                                                            }}
                                                            className="ms-2 border-0 bg-transparent text-white"
                                                            style={{
                                                                padding: '0',
                                                                lineHeight: 1,
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                opacity: 0.8,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Related Saints Section */}
                        <div className="row mb-3">
                            {/* Related Saints Search */}
                            <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Related Saints
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            name="relatedSaint"
                                            placeholder="Search Related Saints"
                                            value={searchSaint}
                                            onChange={(e) => setSearchSaint(e.target.value)}
                                            style={{
                                                height: '44px',
                                                paddingRight: '35px',
                                                paddingLeft: '12px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                        <img
                                            src={Search}
                                            alt="search"
                                            className="position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '16px',
                                                height: '16px',
                                                zIndex: 2
                                            }}
                                        />
                                        {/* Saints Search Results Dropdown */}
                                        {searchSaint.length > 0 && saintResults.length > 0 && saintResults.filter((saint) =>
                                            saint?.name?.toLowerCase().includes(searchSaint.toLowerCase())
                                        ).length > 0 && (
                                                <div
                                                    className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                    style={{
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto'
                                                    }}
                                                >
                                                    {saintResults.filter((saint) =>
                                                        saint?.name?.toLowerCase().includes(searchSaint.toLowerCase())
                                                    ).map(saint => {
                                                        const isSelected = selectedSaints.some(s => s.id === saint.id);
                                                        if (!isSelected) {
                                                            return (
                                                                <div
                                                                    key={saint.id}
                                                                    className="p-2 cursor-pointer hover:bg-gray-100"
                                                                    onClick={() => handleSaintSelect(saint)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {saint.name}
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            )}
                                    </div>
                                </Form.Group>
                            </div>

                            {/* Selected Saints */}
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Selected Saints
                                    </Form.Label>
                                    <div className="position-relative">
                                        <div
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '100px',
                                                height: 'auto',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '0.375rem',
                                                padding: '12px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedSaints.map((saint) => (
                                                    <span
                                                        key={saint.id}
                                                        className="d-inline-flex align-items-center"
                                                        style={{
                                                            backgroundColor: '#6366F1',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            marginBottom: '4px'
                                                        }}
                                                    >
                                                        {saint.name}
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleSaintRemove(saint.id);
                                                            }}
                                                            className="ms-2 border-0 bg-transparent text-white"
                                                            style={{
                                                                padding: '0',
                                                                lineHeight: 1,
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                opacity: 0.8,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Related Projects Section */}
                        <div className="row mb-3">
                            {/* Related Projects Search */}
                            <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Related Projects
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            name="relatedProject"
                                            placeholder="Search Related Projects"
                                            value={searchProject}
                                            onChange={(e) => setSearchProject(e.target.value)}
                                            style={{
                                                height: '44px',
                                                paddingRight: '35px',
                                                paddingLeft: '12px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                        <img
                                            src={Search}
                                            alt="search"
                                            className="position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '16px',
                                                height: '16px',
                                                zIndex: 2
                                            }}
                                        />
                                        {/* Projects Search Results Dropdown */}
                                        {searchProject.length > 0 && projectResults.length > 0 && projectResults.filter((project) =>
                                            project?.project_title?.toLowerCase().includes(searchProject.toLowerCase())
                                        ).length > 0 && (
                                                <div
                                                    className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                    style={{
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto'
                                                    }}
                                                >
                                                    {projectResults.filter((project) =>
                                                        project?.project_title?.toLowerCase().includes(searchProject.toLowerCase())
                                                    ).map(project => {
                                                        const isSelected = selectedProjects.some(p => p.project_id === project.project_id);
                                                        if (!isSelected) {
                                                            return (
                                                                <div
                                                                    key={project.project_id}
                                                                    className="p-2 cursor-pointer hover:bg-gray-100"
                                                                    onClick={() => handleProjectSelect(project)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {project.project_title}
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            )}
                                    </div>
                                </Form.Group>
                            </div>

                            {/* Selected Projects */}
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Selected Projects
                                    </Form.Label>
                                    <div className="position-relative">
                                        <div
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '100px',
                                                height: 'auto',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '0.375rem',
                                                padding: '12px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedProjects.map((project) => (
                                                    <span
                                                        key={project.project_id}
                                                        className="d-inline-flex align-items-center"
                                                        style={{
                                                            backgroundColor: '#6366F1',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            marginBottom: '4px'
                                                        }}
                                                    >
                                                        {project.project_title}
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleProjectRemove(project.project_id);
                                                            }}
                                                            className="ms-2 border-0 bg-transparent text-white"
                                                            style={{
                                                                padding: '0',
                                                                lineHeight: 1,
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                opacity: 0.8,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Promote As & Subscription Type */}
                        <div className="row mb-3">
                            <div className="col-6 mt-4">
                                {/* Promote As */}
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Promote As
                                    </Form.Label>
                                    <div className="d-flex gap-4">
                                        <Form.Check
                                            type="checkbox"
                                            id="trending"
                                            name="trending"
                                            label="Trending"
                                            checked={formData.promotions.trending}
                                            onChange={handleCheckboxChange}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            id="byGuruji"
                                            name="byGuruji"
                                            label="By Guruji"
                                            checked={formData.promotions.byGuruji}
                                            onChange={handleCheckboxChange}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-6 mt-4">
                                {/* Subscription Type */}
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Subscription Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div className="d-flex gap-4">
                                        <Form.Check
                                            type="radio"
                                            id="free"
                                            name="subscriptionType"
                                            value="FREE"
                                            label="Free"
                                            checked={true}
                                            disabled={false}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="paid"
                                            name="subscriptionType"
                                            value="PAID"
                                            label="Paid"
                                            checked={false}
                                            disabled={true}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Is this content part of Explore or a Course? */}
                        <div className="mt-4">
                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                Is this Artifact, part of a Course?
                            </Form.Label>
                            <div className="d-flex gap-4">
                                <Form.Check
                                    type="checkbox"
                                    id="course"
                                    name="course"
                                    label="Yes"
                                    checked={formData.contentType.course}
                                    onChange={handleContentTypeChange}
                                />
                                <Form.Check
                                    type="checkbox"
                                    id="explore"
                                    name="explore"
                                    label="No"
                                    checked={formData.contentType.explore}
                                    onChange={handleContentTypeChange}
                                />
                            </div>
                        </div>

                        {/* Live Text (Mantra/Stotra) section */}
                        {formData.artifactType === 'AUDIO_ORALS' &&
                            // && formData.category === 21 && 
                            (
                                <div className="mt-4">
                                    <Form.Group>
                                        <div className="d-flex align-items-center mb-2">
                                            <Form.Check
                                                type="checkbox"
                                                id="hasLyrics"
                                                label="Live Text (Mantra/Stotra)"
                                                checked={hasLyrics}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setHasLyrics(checked);
                                                    // ✅ Clear lyrics data when unchecking
                                                    if (!checked) {
                                                        setFiles(prev => ({
                                                            ...prev,
                                                            lyricsData: null
                                                        }));
                                                    }
                                                }}
                                                className="me-3"
                                            />
                                        </div>

                                        {hasLyrics && (
                                            <>
                                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                    Lyrics JSON
                                                </Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder='{"lines": [{"time": 0, "text": "First line"}, {"time": 3.5, "text": "Second line"}]}'
                                                    value={files.lyricsData ? JSON.stringify(files.lyricsData, null, 2) : ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (!value.trim()) {
                                                            setFiles(prev => ({
                                                                ...prev,
                                                                lyricsData: null
                                                            }));
                                                            return;
                                                        }

                                                        try {
                                                            const parsed = JSON.parse(value);
                                                            if (!parsed.lines || !Array.isArray(parsed.lines)) {
                                                                toast.error("Invalid format. Expected {lines: [{time: number, text: string}]}");
                                                                return;
                                                            }
                                                            setFiles(prev => ({
                                                                ...prev,
                                                                lyricsData: parsed
                                                            }));
                                                        } catch (error) {
                                                            // Don't show error while typing
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        // Validate on blur
                                                        const value = e.target.value;
                                                        if (value.trim() && value !== '') {
                                                            try {
                                                                JSON.parse(value);
                                                            } catch (error) {
                                                                toast.error("Invalid JSON format");
                                                            }
                                                        }
                                                    }}
                                                    style={{
                                                        height: '150px',
                                                        fontSize: '12px',
                                                        fontFamily: 'monospace',
                                                        resize: 'vertical'
                                                    }}
                                                />
                                                <Form.Text className="text-muted" style={{ fontSize: '10px' }}>
                                                    Enter lyrics in JSON format with time in seconds
                                                </Form.Text>
                                            </>
                                        )}
                                    </Form.Group>
                                </div>
                            )}

                        {/* Insights Area */}
                        <div className="mt-5">
                            <h6 className="text-primary mb-4" style={{ fontSize: '16px', color: '#6366F1' }}>Insights Area</h6>
                            <div className="d-flex align-items-center gap-4" style={{ background: "#F8FAFC", width: '670px', height: '150px', padding: '0 12px', borderRadius: '8px' }}>
                                <div style={{
                                    background: 'white',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    width: '200px',
                                    height: '125px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <p className="mb-1 text-muted text-center" style={{ fontSize: '14px' }}>No. of Clicks</p>
                                    <h5 className="mb-0 text-center" style={{ fontSize: '20px', fontWeight: '500' }}>
                                        {insights.total_clicks || 0}
                                    </h5>
                                </div>
                                <div style={{
                                    background: 'white',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    width: '200px',
                                    height: '125px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <p className="mb-1 text-muted text-center" style={{ fontSize: '14px' }}>No. of Views/Eyeballs</p>
                                    <h5 className="mb-0 text-center" style={{ fontSize: '20px', fontWeight: '500' }}>
                                        {insights.total_views || 0}
                                    </h5>
                                </div>
                                <div style={{
                                    background: 'white',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    width: '200px',
                                    height: '125px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <p className="mb-1 text-muted text-center" style={{ fontSize: '14px' }}>Avg. Time Spent</p>
                                    <h5 className="mb-0 text-center" style={{ fontSize: '20px', fontWeight: '500' }}>
                                        {insights.avg_duration || 0} Min
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>

                {/* Preview Modal */}
                <Modal
                    show={showPreview}
                    onHide={() => setShowPreview(false)}
                    size="lg"
                    centered
                    className="preview-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Mobile Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0, display: 'flex', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
                        <div style={{
                            width: '280px',
                            height: '580px',
                            backgroundColor: 'white',
                            margin: '20px',
                            borderRadius: '25px',
                            padding: '20px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                            border: '8px solid #2c3e50',
                            position: 'relative',
                            overflow: 'hidden',
                            boxSizing: 'border-box'
                        }}>
                            {/* Header */}
                            <div style={{
                                textAlign: 'center',
                                padding: '5px 0',
                                borderBottom: '1px solid #e0e0e0',
                                marginBottom: '20px'
                            }}>
                                <h4 style={{ color: '#333', margin: 0 }}>Literature</h4>
                            </div>

                            {/* Title */}
                            <div style={{
                                textAlign: 'center',
                                marginBottom: '20px'
                            }}>
                                <h5 style={{ color: '#333', margin: 0, fontWeight: '600', wordWrap: 'break-word', maxWidth: '100%' }}>
                                    {formData.title || 'Your Title Here'}
                                </h5>
                            </div>

                            {/* Content */}
                            <div style={{
                                height: '400px',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                boxSizing: 'border-box',
                                padding: '0 10px',
                                fontSize: '14px',
                                lineHeight: '1.6',
                                color: '#333',
                                msOverflowStyle: 'none',   // Hides scrollbar in IE/Edge
                                scrollbarWidth: 'none',    // Hides scrollbar in Firefox
                                '::-webkit-scrollbar': {   // Hides scrollbar in Chrome/Safari
                                    display: 'none'
                                }
                            }}>
                                <div
                                    style={{
                                        maxWidth: '100%',
                                        wordWrap: 'break-word',
                                        wordBreak: 'break-word',
                                        overflow: 'hidden'
                                    }}
                                    className="preview-content"
                                >
                                    <div
                                        dangerouslySetInnerHTML={{ __html: processHtmlForPreview(contentByLanguage.en || htmlContent) }}
                                        style={{
                                            maxWidth: '100%',
                                            wordWrap: 'break-word',
                                            wordBreak: 'break-word',
                                            overflow: 'hidden'
                                        }}
                                        className="preview-content"
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </Modal.Body>

            <Modal.Footer className="border-top-1">
                <Button
                    variant="primary"
                    className="px-4 py-2 ms-auto"
                    style={{ backgroundColor: '#6366F1' }}
                    onClick={handleSubmit}
                    disabled={isSubmitting || isSubmitted}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditLearning;